import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import style from './subscribe.module.css'
import { subUnlimitedAnimationAtom, isFeedbackModalOpenAtom, showSubscribeTimesAtom, logInfoAtom, subscriptionsEduStateAtom, showLoginAtom, promotionsAtom, showSubscribeAtom, subscriptionsInfoAtom, subscriptionsUnlimitInfoAtom, showApiDashboardAtom, currentNavAtom, subscriptionsPreInfoAtom } from '../../store'
import { useRef, useState, useEffect, useContext } from 'react'
import { getDashBoardLink, subscribeToPlan, sendEduEmail, EduSubmit, changePlan } from '../../utils/net'
import { useTips } from '../../common/GlobalTips'
import { FaArrowRight } from "react-icons/fa6";
import checkIcon_1 from './assets/checkIcon_1.png'
import checkIcon_2 from './assets/checkIcon_2.png'
import subPrice from './assets/subPrice.png'
import subPricefree from './assets/subPricefree.png'
import flashIcon from './assets/flash.png'
import fireIcon from './assets/fire.png'
import starIcon from './assets/star.png'
import star2Icon from './assets/star2.png'
import heartIcon from './assets/heart.png'
import unlimitedIcon from './assets/unlimitedicon.svg'
import unlimitedInitIcon from './assets/unlimitInit.png'
import { Iframe } from '../widgets/Iframe'
import ReactGA from "react-ga4";
import gsap from "gsap";
import { CustomEase } from 'gsap/CustomEase';
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import Restricted from "../../utils/restricted";
import { t } from "i18next";
import { trackEvent } from '../../utils/trackEvent'
import { PermissionContext } from '../../utils/context'
// import styles from "../Promotional/Blackfriday/blackfriday.module.css";

const CreatorPrice = [30, 60, 120, 180, 240]
const BusinessPrice = [120, 240, 480, 720, 1200]
const UnlimitedPrice = 300


const MyPlanTier = ({ eduHover, setMyPlanHover, myPlanHover }) => {
  const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  const { t } = useTranslation();
  const { isCreatorOrAbove } = useContext(PermissionContext);
  const planType = subscriptionsInfo.plan_level ? (subscriptionsInfo.plan_yearly ? t('SUBSCRIPTION_YEARLY') : t('SUBSCRIPTION_MONTHLY')) : null;

  const benefitsMap = {
    Creator: [
      t('SUBSCRIPTION_CREATOR_BENE_FITS_1'),
      subscriptionsInfo.plan_yearly ? t('SUBSCRIPTION_CREATOR_BENE_FITS_7_2') : t('SUBSCRIPTION_CREATOR_BENE_FITS_7_1'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_2'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_3'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_4'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_5'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_6')
    ],
    Education: [
      t('SUBSCRIPTION_CREATOR_BENE_FITS_1'),
      subscriptionsInfo.plan_yearly ? t('SUBSCRIPTION_EDU_BENE_FITS_7_2') : t('SUBSCRIPTION_EDU_BENE_FITS_7_1'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_2'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_3'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_4'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_5'),
      t('SUBSCRIPTION_CREATOR_BENE_FITS_6')

    ],
    Business: [
      t('SUBSCRIPTION_BUSS_BENE_FITS_1'),
      subscriptionsInfo.plan_yearly ? t('SUBSCRIPTION_BUSS_BENE_FITS_6_2') : t('SUBSCRIPTION_BUSS_BENE_FITS_6_1'),
      t('SUBSCRIPTION_BUSS_BENE_FITS_2'),
      t('SUBSCRIPTION_BUSS_BENE_FITS_3'),
      t('SUBSCRIPTION_BUSS_BENE_FITS_4'),
      t('SUBSCRIPTION_BUSS_BENE_FITS_5')
    ],
    Enterprise: [
      t('SUBSCRIPTION_ENT_BENE_FITS_1'),
      t('SUBSCRIPTION_ENT_BENE_FITS_2'),
      t('SUBSCRIPTION_ENT_BENE_FITS_3'),
      t('SUBSCRIPTION_ENT_BENE_FITS_4'),
      t('SUBSCRIPTION_ENT_BENE_FITS_5')
    ],
    Free: [
      t('SUBSCRIPTION_FREE_BENE_FITS_1'),
      t('SUBSCRIPTION_FREE_BENE_FITS_2'),
      t('SUBSCRIPTION_FREE_BENE_FITS_3')
    ],
    Unlimited: [
      t('SUBSCRIPTION_BUSS_BENE_FITS_1'),
      t('SUBSCRIPTION_UNLIMITED_BENE_FITS'),
      t('SUBSCRIPTION_BUSS_BENE_FITS_2'),
      t('SUBSCRIPTION_BUSS_BENE_FITS_3'),
      t('SUBSCRIPTION_BUSS_BENE_FITS_4'),
      t('SUBSCRIPTION_BUSS_BENE_FITS_5')
    ]
  }

  const titleList = {
    'Education': t('SUBSCRIPTION_PLAN_EDUCATION'),
    'Creator': t('SUBSCRIPTION_PLAN_CREATOR'),
    'Business': t('SUBSCRIPTION_PLAN_BUSINESS'),
    'Enterprise': t('SUBSCRIPTION_PLAN_ENTERPRISE'),
    'Unlimited': t('SUBSCRIPTION_PLAN_UNLIMITED')
  }

  const LangFreeBeneFits = benefitsMap[subscriptionsInfo.plan_level] || benefitsMap.Free;

  const formattedDate = (date) => {
    const formatDate = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    }).format(date);
    return formatDate
  }

  const myInfo = {
    title: titleList[subscriptionsInfo.plan_level] || t('SUBSCRIPTION_PLAN_FREE'),
    monthQuota: (subscriptionsInfo.plan_level && subscriptionsInfo.plan_price) || 0,
    unitPrice: planType || '$1.5',
    equityContent: LangFreeBeneFits,
    expiration: subscriptionsInfo?.end_time ? formattedDate(new Date(subscriptionsInfo.end_time.split('T')[0])) : false
  }
  //348 541   0.231  1.555

  return (
    <div onMouseEnter={() => { setMyPlanHover(true) }} onMouseLeave={() => { setMyPlanHover(false) }} className={`group w-[177px]  xs:w-[232px]  sm:w-[254px] h-[130px] xs:h-[130px] sm:h-[139px] md:h-[162px] lg:h-[191px] xl:h-[191px] hover:h-[195px] hover:xs:h-[208px] hover:sm:h-[225px] hover:md:h-[273px] hover:lg:h-[348px] hover:xl:h-[347px] md:w-[290px]  lg:w-[349px]  xl:w-[348px]  bg-[rgba(51,51,51,0.8)] flex flex-col rounded-2xl [transition:all_0.3s_ease]`}>
      <div className={`relative shrink-0 w-full h-[130px] sm:h-[139px] md:h-[162px] lg:h-[191px] group-hover:h-[126px] group-hover:sm:h-[136px] group-hover:md:h-[156px] group-hover:lg:h-[176px] flex flex-col items-start px-[16px] sm:px-[22px] md:px-[28px] lg:px-[32px] py-[8px] sm:py-[8px] md:py-[12px] lg:py-[16px] rounded-2xl group-hover:rounded-t-2xl bg-[rgba(66,66,66,0.4)] [transition:all_0.3s_ease]`}>
        <div className='bg-[rgba(73,73,73,0.2)] text-[rgba(240,240,240,1)] flex-nowrap absolute right-[10px] top-[10px] flex-center w-max text-[12px] sm:text-[14px] font-bold px-[8px] py-[6px] md:px-[14px] md:py-[10px] [border-radius:4px_16px_4px_4px]'>
          {t('SUBSCRIPTION_CURRENT_PLAN')}
        </div>
        <span className='font-bold text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px]  text-[rgba(214,214,214,1)]'>{myInfo.title}</span>
        <div className='text-subscription-price-sm lg:text-[20px] leading-[12px] sm:leading-[14px] md:leading-[16px] lg:leading-[20px] pt-[12px] pb-[8px] sm:pt-[12px] sm:pb-[10px]  md:pt-[12px] md:pb-[14px] lg:pt-[20px] lg:pb-[16px] text-[rgba(214,214,214,1)]'>
          <span className='relative pr-4 h-fit inline-block'>
            <span className='text-subscription-price font-bold'>{myInfo.monthQuota}</span>
            <img className='absolute right-1 top-0 -translate-y-[50%] w-[6px] xs:w-[8px] sm:w-[10px] h-auto' src={subPricefree} alt="$" />
          </span>
          <span className='text-subscription-price-sm '>/ {t('SUBSCRIPTION_MONTH')}</span>
        </div>
        {myInfo.expiration && <span className='text-subscription-price-sm absolute bottom-[24%] text-[rgba(162,162,162,1)]'>{subscriptionsInfo.plan_level === 'Unlimited' ? t('SUBSCRIPTION_PLAN_EXPIRATION') : t('SUBSCRIPTION_PLAN_NEXT_BILLING')}: {myInfo.expiration}</span>}
        <span className='text-subscription-price-sm [transition:all_0.3s_ease] absolute bottom-[10%] text-[rgba(162,162,162,1)]'>
          <span>{myInfo.unitPrice}</span>
          {!isCreatorOrAbove() && <span>/{t('WALLET_CREDIT')}</span>}
        </span>
      </div>
      {myPlanHover && <div className='px-[16px] py-[7px] h-[100%] overflow-scroll'>
        <div className='w-full mt-[2%] h-[90%] flex flex-col rounded-lg overflow-scroll bg-[rgba(255,255,255,0.03)] px-4 py-2 gap-2'>
          {myInfo.equityContent.map((item, index) => {
            return (
              <div className='text-[12px] md:text-[14px] text-[rgba(242,242,242,1)] flex  w-full gap-2 items-start' key={index}>
                <img className='w-[14px] h-[14px]' src={checkIcon_1} alt="√" />
                <span className='text-left'>{item}</span>
              </div>
            )
          })}
        </div>
        {/* <div className='text-[14px] md:text-[16px] lg:text-[18px] w-full h-[44px] cursor-pointer bg-[rgba(56,56,56,1)] font-bold flex-center text-[rgba(194,194,194,1)] rounded-xl mt-2'>Get Started</div> */}
      </div>}
    </div>
  )
}

const EducationTier = ({ yearChecked, setOpenEduHover, myPlanHover, fetchver, setFetchver, loading, setLoading }) => {
  const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  // const [showSubscribe,] = useRecoilState(showSubscribeAtom)
  const logInfo = useRecoilValue(logInfoAtom)
  const subscriptionsEduState = useRecoilValue(subscriptionsEduStateAtom)
  const setShowLogin = useSetRecoilState(showLoginAtom);
  const { t } = useTranslation();
  const tip = useTips();
  const [isVerify, setIsVerify] = useState(false)
  const [isExpired, setIsExpired] = useState(false)
  const [tagshow, setTagshow] = useState(false)
  const [creditHover, setCreditHover] = useState(false)
  const { isCreatorOrAbove } = useContext(PermissionContext);

  const myInfo = {
    title: t('SUBSCRIPTION_PLAN_EDUCATION'),
    monthQuota: yearChecked ? 24 : 30,
  }

  const LangCreatorBeneFits = [
    t('SUBSCRIPTION_CREATOR_BENE_FITS_1'),
    yearChecked ? t('SUBSCRIPTION_EDU_BENE_FITS_7_2') : t('SUBSCRIPTION_EDU_BENE_FITS_7_1'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_2'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_3'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_4'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_5'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_6')
  ]

  const eduConfirm = async () => {
    setLoading(true)
    if (!logInfo) {
      setLoading(false)
      setShowLogin(true);
      return;
    } else {
      if (isCreatorOrAbove()) {
        if (subscriptionsInfo.plan_level === 'Education') {
          tip({
            type: 'primary',
            content: t('TIP_PRIMARY_SUB_CURRENT_PLAN'),
          });
        } else {
          tip({
            type: 'warning',
            content: t('TIP_WRAN_SUB_SWITCH_EDU_PLAN'),
          });
        }
        setLoading(false)
      } else {
        if (!isVerify) {
          trackEvent('Subscribe - Education - Verify Page: Open')
          setLoading(false)
          setOpenEduHover(true)
        } else {
          if (isExpired) {
            trackEvent('Subscribe - Education - Plan: Expired')
            tip({
              type: 'warning',
              content: t('TIP_WRAN_SUB_EDU_EXPIRED'),
            });
            setLoading(false)
          } else {
            try {
              const param = {
                billing_provider: 'Stripe',
                plan_level: 'Education',
                plan_monthly_price: yearChecked ? '12' : '15',
                yearly: yearChecked
              }
              trackEvent('Subscribe - Education - Plan: Change', param)
              const result = await subscribeToPlan(param)
              if (result?.data?.error) {
                setLoading(false)
                return
              }
              if (result?.data?.url) {
                window.location.href = result?.data?.url;
              }
              setLoading(false)
            } catch (e) {
              setLoading(false)
              console.log('subscribeerror', e)
            }
          }
        }
      }
    }
  }

  useEffect(() => {
    if (subscriptionsInfo && logInfo) {
      setIsVerify(subscriptionsEduState.isVerified)
      if (subscriptionsEduState.isVerified && subscriptionsEduState.isExpired) {
        setIsExpired(true)
      }
      setTagshow(true)
    }
  }, [subscriptionsInfo, logInfo])

  return (
    <div className={`group w-[177px] bottom-[101px] xs:w-[232px] xs:bottom-[144px] sm:w-[254px] sm:bottom-[151px] md:w-[290px] md:bottom-[161px] lg:w-[349px] lg:bottom-[206px] xl:w-[348px] xl:bottom-[204px] flex flex-col rounded-2xl [transition:all_0.3s_ease]
    ${myPlanHover ? 'h-[72px] xs:h-[145px] sm:h-[162px] md:h-[171px] lg:h-[186px] xl:h-[184px] [background:linear-gradient(128.84deg,rgba(135,113,255,1)_33.22%,rgba(124,181,223,1)_97.1%)]' : 'h-[173px] xs:h-[223px] sm:h-[248px] md:h-[280px] lg:h-[341px] xl:h-[341px] [background:linear-gradient(128.84deg,rgba(91,90,163,1)_33.22%,rgba(79,78,142,1)_97.1%)]'}`}>
      <div className={`relative shrink-0 w-full flex flex-col items-start px-[16px] sm:px-[22px] md:px-[28px] lg:px-[32px] py-[8px] sm:py-[8px] md:py-[12px] lg:py-[16px] rounded-t-2xl [transition:all_0.3s_ease]
      ${myPlanHover ? 'h-[60px] sm:h-[70px] md:h-[84px] lg:h-[94px] bg-none' : 'h-[75px] sm:h-[85px] md:h-[99px] lg:h-[119px] bg-[linear-gradient(128.84deg,rgba(135,113,255,1)_33.22%,rgba(124,181,223,1)_97.1%)]'}`}>
        <div className='font-bold w-full flex flex-row items-center justify-between text-[12px] sm:text-[16px] md:text-[18px] lg:text-[20px] text-white'>
          <span>{myInfo.title}</span>
          <div className={`${tagshow ? 'opacity-100' : 'opacity-0'} [transition:all_0.1s_ease] bg-[rgba(255,255,255,0.15)] text-white flex-nowrap relative flex-center w-max text-[10px] sm:text-[12px] lg:text-[14px] font-[400] px-[6px] py-[2px] md:px-[10px] -mr-[15px] [border-radius:16px_16px_16px_16px]
          after:absolute after:contents-[""] after:aspect-square after:h-[35%]  after:rounded-[100%] after:right-[2%] after:-top-[10%] ${isVerify ? isExpired ? 'after:bg-[#FF3636]' : 'after:bg-[#2EFF5C]' : 'after:bg-[#FF3636]'}`}>
            {isVerify ? isExpired ? t('SUBSCRIPTION_EDU_TIPS_1') : t('SUBSCRIPTION_EDU_TIPS_2') : t('SUBSCRIPTION_EDU_TIPS_3')}
          </div>
        </div>
        <div className='text-subscription-price-sm lg:text-[20px] leading-[12px] sm:leading-[14px] md:leading-[16px] lg:leading-[20px] pt-[8px] sm:pt-[8px] md:pt-[8px] lg:pt-[10px] relative text-white'>
          <span className='relative pr-4 h-fit inline-block'>
            <span className='text-subscription-price font-bold'>{yearChecked ? '12' : '15'}</span>
            <img className='absolute right-1 top-0 -translate-y-[50%] w-[6px] xs:w-[8px] sm:w-[10px] h-auto' src={subPrice} alt="$" />
            <span className='absolute translate-y-[30%] xs:translate-y-[28%] lg:translate-y-[30%] xl:translate-y-[40%] -right-2 xs:-right-3 text-subscription-price-sm lg:text-[20px] font-bold line-through text-[rgba(214,214,214,0.7)]  decoration-white'>{myInfo.monthQuota}</span>
          </span>
          <span className='text-subscription-price-sm ml-3 xs:ml-5'>/ {t('SUBSCRIPTION_MONTH')}</span>
          <span onMouseEnter={() => { setCreditHover(true) }} onMouseLeave={() => { setCreditHover(false) }} className='relative top-[-1px] xs:top-[-4px] ml-[5px] sm:ml-[5px] lg:ml-[8px] bg-[rgba(240,234,255,1)] rounded px-[4px] py-[2px] xs:px-1 xs:py-[3px] lg:px-2 lg:py-[6px] text-[8px] xs:text-xs text-[rgba(148,102,242,1)]'>
            <span>
              {!creditHover ? '~60' : yearChecked ? '$0.4' : '$0.5'}
            </span>
            <span >{!creditHover ? ' Assets' : `/${t('WALLET_CREDIT')}`}</span>
          </span>
          <span className='text-subscription-price-sm absolute left-0 -bottom-[60%] sm:-bottom-[80%] md:-bottom-[60%] lg:-bottom-[45%] xl:-bottom-[45%] whitespace-nowrap text-[rgba(243,243,243,1)]'>
            <span>30</span>
            <span>&nbsp;credits per month</span>
          </span>
        </div>
      </div>
      <div className={`w-full h-full  flex flex-col  overflow-scroll [transition:all_0.1s_ease]
      ${myPlanHover ? 'p-0 pb-1 invisible opacity-0' : 'p-4 pb-1 visible opacity-100'}`}>
        <div className='w-full flex flex-col rounded-lg overflow-scroll bg-[rgba(255,255,255,0.03)] p-4 gap-2'>
          {LangCreatorBeneFits.map((item, index) => {
            return (
              <div className='text-[12px] md:text-[14px] text-[rgba(242,242,242,1)] flex  w-full gap-2 items-start' key={index}>
                <img className='w-[14px] h-[14px]' src={checkIcon_2} alt="√" />
                <span className='text-left'>{item}</span>
              </div>
            )
          })}
        </div>
      </div>
      <div className='p-[16px]' onClick={loading ? () => { } : eduConfirm}>
        <div className={`text-[14px] md:text-[16px] lg:text-[18px] w-full h-[54px] ${loading ? ' cursor-not-allowed' : ' cursor-pointer hover:bg-[#807fd3]'} bg-[#625FD0]  flex-center text-[rgba(255,255,255,1)] font-bold rounded-xl [transition:all_0.3s_ease]`}>{!isCreatorOrAbove() ? t('SUBSCRIPTION_BTN_TIPS_2_1') : t('SUBSCRIPTION_BTN_TIPS_2_2')}</div>
      </div>
    </div>
  )
}

const CreatorTier = ({ yearChecked, creatorPriceIndex, setCreatorPriceIndex, handlerChoosePlan, loading }) => {
  const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  const subscriptionsPreInfo = useRecoilValue(subscriptionsPreInfoAtom)
  const logInfo = useRecoilValue(logInfoAtom)
  const { t } = useTranslation();
  const [creditHover, setCreditHover] = useState(false)
  const { isCreatorOrAbove } = useContext(PermissionContext);

  const LangCreatorBeneFits = [
    t('SUBSCRIPTION_CREATOR_BENE_FITS_1'),
    yearChecked ? t('SUBSCRIPTION_CREATOR_BENE_FITS_7_2') : t('SUBSCRIPTION_CREATOR_BENE_FITS_7_1'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_2'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_3'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_4'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_5'),
    t('SUBSCRIPTION_CREATOR_BENE_FITS_6')
  ]

  const showTrial = creatorPriceIndex === 0 && yearChecked;
  const showMoTrial = creatorPriceIndex === 0 && !yearChecked;
  return (
    <div className='w-[177px] h-[275px] xs:w-[232px] xs:h-[360px] sm:w-[254px] sm:h-[395px]  md:w-[290px] md:h-[451px] lg:w-[349px] lg:h-[542px] xl:w-[348px] xl:h-[541px] bg-[linear-gradient(180deg,#645588_33.24%,#484848_100%)] flex flex-col rounded-2xl'>
      <div className='relative shrink-0 w-full h-[124px] sm:h-[134px]  md:h-[154px] lg:h-[174px] flex flex-col items-start px-[16px] sm:px-[22px] md:px-[28px] lg:px-[32px] py-[8px] sm:py-[8px] md:py-[12px] lg:py-[16px] rounded-t-2xl bg-[linear-gradient(116.99deg,#875DE7_17.95%,#A08BD5_78.53%)]'>
        {/* {subscriptionsInfo.plan_level === 'Creator' ? (
          <div className='bg-[rgba(0,0,0,0.2)] text-[rgba(255,255,255,1)] flex-nowrap absolute right-[10px] top-[10px] flex-center w-max text-[12px] sm:text-[14px] font-bold px-[8px] py-[6px] md:px-[14px] md:py-[10px] [border-radius:4px_16px_4px_4px]'>
            Your Plan
          </div>
        ) :  */}
        {showTrial && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && (
          <div className="absolute gap-1 right-[10px] top-[10px] flex items-center px-[10px] py-[1px] md:py-[1px] lg:py-[3px] bg-[linear-gradient(96.13deg,#FB5F1F_-4.12%,#F7AF31_102.42%)] [border-radius:3.51px_10.54px_3.51px_11px] xs:[border-radius:3.51px_10.54px_3.51px_12px] sm:[border-radius:3.51px_10.54px_3.51px_13px] md:[border-radius:3.51px_10.54px_3.51px_14px] lg:[border-radius:3.51px_10.54px_3.51px_15px] text-primary text-[#fff] font-bold ">
            <span className='text-[20px] md:text-[28px] lg:text-[31px]'>7</span>
            <div className='flex flex-col'>
              <span className='text-[10px] leading-3'>FREE</span>
              <span className='text-[12px] md:text-[12px] lg:text-[14px] leading-3 '>-DAY</span>
            </div>
          </div>
        )}
        {showMoTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 && <div className="absolute gap-1 right-[10px] top-[10px] flex items-center px-[10px] py-[3px] bg-[linear-gradient(97.95deg,#45E1FF_-22.77%,#FF8235_115.3%)] [border-radius:3.51px_10.54px_3.51px_11px] xs:[border-radius:3.51px_10.54px_3.51px_12px] sm:[border-radius:3.51px_10.54px_3.51px_13px] md:[border-radius:3.51px_10.54px_3.51px_14px] lg:[border-radius:3.51px_10.54px_3.51px_15px] text-primary text-[#fff] font-bold ">
          <div className='flex flex-row items-start'>
            <span className='text-[12px] xs:text-[15px] xs:leading:text-[14px] sm:text-[18px] md:text-[20px] lg:text-[28px]'>33</span>
            <span className='text-[6px] xs:text-[9px] sm:text-[10px]'>%</span>
          </div>
          <div className='flex flex-col w-[9px]  h-[14px] xs:w-[19px] xs:h-[20px] sm:w-[20px] sm:h-[22px] md:w-[23px] md:h-[23px] lg:w-[35px]  lg:h-[30px] relative items-center'>
            <span className='text-[6px] xs:text-[8px] sm:text-[9px] md:text-[9px] lg:text-[12px] absolute top-0 right-0'>OFF</span>
            <span className='text-[4.5px] xs:text-[7.5px] sm:text-[8px] md:text-[8.5px] lg:text-[11px] absolute whitespace-nowrap bottom-0 right-0'>First Mo</span>
          </div>
        </div>}
        <span className='font-bold text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] text-white'>{t('SUBSCRIPTION_PLAN_CREATOR')}</span>
        <div className='text-[14px] xs:text-[16px] sm:text-[18px] md:text-[20px] lg:text-[24px] leading-[16px] sm:leading-[18px] md:leading-[20px] lg:leading-[24px] pt-[14px] pb-[18px] sm:pt-[14px] sm:pb-[20px]  md:pt-[14px] md:pb-[24px] lg:pt-[16px] lg:pb-[26px] text-white'>
          {showMoTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 && <span className='absolute text-[rgba(255,255,255,0.6)] text-[10px] sm:text-[11px] md:text-[12px] lg:text-[15px] translate-y-[16px] sm:translate-y-[18px] md:translate-y-[22px] lg:translate-y-[28px] '>${CreatorPrice[creatorPriceIndex]} / month thereafter</span>}
          <span className='relative pr-1 xs:pr-3 h-fit inline-block'>
            <span className='text-subscription-price font-bold'>{yearChecked ? CreatorPrice[creatorPriceIndex] * 0.8 : showMoTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? '20' : CreatorPrice[creatorPriceIndex]}</span>
            <img className='absolute -right-1 top-0 -translate-y-[50%] w-[6px] xs:w-[8px] sm:w-[10px] h-auto' src={subPrice} alt="$" />
          </span>
          <span className='text-subscription-price-sm'>/ {showMoTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 'first mo.' : t('SUBSCRIPTION_MONTH')}</span>
          <span onMouseEnter={() => { setCreditHover(true) }} onMouseLeave={() => { setCreditHover(false) }} className='relative top-[-4px] ml-[5px] sm:ml-[5px] lg:ml-[8px] bg-[rgba(240,234,255,1)] rounded px-1 py-[3px] lg:px-2 lg:py-[6px] text-[8px] xs:text-[10px] sm:text-[10px] md:text-xs text-[rgba(148,102,242,1)]'>
            <span>
              {!creditHover ? '~' + Math.floor(CreatorPrice[creatorPriceIndex] / 1.5 * 1.5 / 0.5) : '$' + Math.floor(((yearChecked ? CreatorPrice[creatorPriceIndex] * 0.8 : showMoTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? CreatorPrice[creatorPriceIndex] * 0.66 : CreatorPrice[creatorPriceIndex]) / (CreatorPrice[creatorPriceIndex] / 1.5 * 1.5)) * 100) / 100}
            </span>
            <span>{!creditHover ? ' Assets' : `/${t('WALLET_CREDIT')}`}</span>
          </span>
        </div>
        <span className='text-subscription-price-sm leading-[12px] sm:leading-[14px] md:leading-[16px] text-[rgba(243,243,243,1)]'>
          <span>{CreatorPrice[creatorPriceIndex] / 1.5 * 1.5}</span>
          <span>&nbsp;{t('SUBSCRIPTION_CREDIT_MONTHLY')}</span>
        </span>
        <Temperature
          sliderVal={creatorPriceIndex}
          setSliderVal={setCreatorPriceIndex}
        />
      </div>
      <div className='w-full h-full flex flex-col p-4 overflow-scroll'>
        <div className='w-full flex flex-col rounded-lg bg-[rgba(255,255,255,0.03)] p-4 gap-2'>
          {LangCreatorBeneFits.map((item, index) => {
            return (
              <div className='text-[12px] md:text-[14px] text-[rgba(242,242,242,1)] flex  w-full gap-2 items-start' key={index}>
                <img className='w-[14px] h-[14px]' src={checkIcon_2} alt="√" />
                <span className='text-left'>{item}</span>
              </div>
            )
          })}
        </div>
      </div>
      <div className='p-[16px]'>
        {showTrial && (
          <div className=' text-[9px] md:text-[12px] text-[rgb(146,146,146)] px-[10px] py-[5px] rounded-[5px]'>
            {t('SUBSCRIPTION_CREATOR_EXEG')}
          </div>
        )}
        <div
          onClick={loading ? () => { } : handlerChoosePlan.bind(null, 'Creator')}
          className={`text-[14px] md:text-[16px] lg:text-[18px] w-full h-[54px] bg-[linear-gradient(272.06deg,#887BCA_0%,#6655BC_100%)] [transition:all_0.3s_ease] flex-center text-[rgba(255,255,255,1)] font-bold rounded-xl ${loading ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-[linear-gradient(272.06deg,#B166FB_0%,#795EFC_50%,#8067FD_100%)]'}`}>
          {!isCreatorOrAbove() ? t('SUBSCRIPTION_BTN_TIPS_2_1') : t('SUBSCRIPTION_BTN_TIPS_2_2')}
        </div>
      </div>
    </div>
  )
}

const BussinessTier = ({ yearChecked, businessPriceIndex, setBusinessPriceIndex, handlerChoosePlan, loading }) => {
  const setShowApiDashboard = useSetRecoilState(showApiDashboardAtom)
  const setShowSubscribe = useSetRecoilState(showSubscribeAtom)
  const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  const subscriptionsPreInfo = useRecoilValue(subscriptionsPreInfoAtom)
  const logInfo = useRecoilValue(logInfoAtom)
  const [apiHover, setApiHover] = useState(false)
  const [creditHover, setCreditHover] = useState(false)
  const { t } = useTranslation();
  const { isCreatorOrAbove } = useContext(PermissionContext);

  const LangBusinessBeneFits = [
    t('SUBSCRIPTION_BUSS_BENE_FITS_1'),
    yearChecked ? t('SUBSCRIPTION_BUSS_BENE_FITS_6_2') : t('SUBSCRIPTION_BUSS_BENE_FITS_6_1'),
    t('SUBSCRIPTION_BUSS_BENE_FITS_2'),
    t('SUBSCRIPTION_BUSS_BENE_FITS_3'),
    t('SUBSCRIPTION_BUSS_BENE_FITS_4'),
    t('SUBSCRIPTION_BUSS_BENE_FITS_5')
  ]

  const handlerToApiDashboard = () => {
    try {
      const url = new URL(window.location.href)
      url.pathname = "/api-dashboard"
      // window.history.pushState(
      //   { page: "api-dashboard" },
      //   "ApiDashboard Page",
      //   url
      // );
    } catch (e) {
      Sentry.captureException(e)
      console.error(e)
    }
    trackEvent('Rodin - ApiDashboard: Open')
    setShowApiDashboard(true)
    setShowSubscribe(false)
  }

  const showTrial = businessPriceIndex === 0 && !yearChecked;
  return (
    <div className='w-[177px] h-[275px] xs:w-[232px] xs:h-[360px] sm:w-[254px] sm:h-[395px]  md:w-[290px] md:h-[451px] lg:w-[349px] lg:h-[542px] xl:w-[348px] xl:h-[541px] bg-[linear-gradient(180deg,#645588_33.24%,#484848_100%)] flex flex-col rounded-2xl'>
      <div className='relative shrink-0 w-full h-[124px] sm:h-[134px]  md:h-[154px] lg:h-[174px] flex flex-col items-start px-[16px] sm:px-[22px] md:px-[28px] lg:px-[32px] py-[8px] sm:py-[8px] md:py-[12px] lg:py-[16px] rounded-t-2xl bg-[linear-gradient(128.84deg,rgba(250,191,101,0.8)_-6.41%,rgba(202,153,158,0.8)_33.22%,rgba(149,117,227,0.8)_97.1%)]'>
        {showTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 && <div className="absolute gap-1 right-[10px] top-[10px] flex items-center px-[10px] py-[3px] bg-[linear-gradient(97.95deg,#45E1FF_-22.77%,#FF8235_115.3%)] [border-radius:3.51px_10.54px_3.51px_11px] xs:[border-radius:3.51px_10.54px_3.51px_12px] sm:[border-radius:3.51px_10.54px_3.51px_13px] md:[border-radius:3.51px_10.54px_3.51px_14px] lg:[border-radius:3.51px_10.54px_3.51px_15px] text-primary text-[#fff] font-bold ">
          <div className='flex flex-row items-start'>
            <span className='text-[12px] xs:text-[15px] xs:leading:text-[14px] sm:text-[18px] md:text-[20px] lg:text-[28px]'>50</span>
            <span className='text-[6px] xs:text-[9px] sm:text-[10px]'>%</span>
          </div>
          <div className='flex flex-col w-[9px]  h-[14px] xs:w-[19px] xs:h-[20px] sm:w-[20px] sm:h-[22px] md:w-[23px] md:h-[23px] lg:w-[35px]  lg:h-[30px] relative items-center'>
            <span className='text-[6px] xs:text-[8px] sm:text-[9px] md:text-[9px] lg:text-[12px] absolute top-0 right-0'>OFF</span>
            <span className='text-[4.5px] xs:text-[7.5px] sm:text-[8px] md:text-[8.5px] lg:text-[11px] absolute whitespace-nowrap bottom-0 right-0'>First Mo</span>
          </div>
        </div>}
        <span className='font-bold text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] text-white'>{t('SUBSCRIPTION_PLAN_BUSINESS')}</span>
        <Restricted to="api.view">
          <div onClick={logInfo ? handlerToApiDashboard : () => { }} onMouseEnter={setApiHover.bind(null, true)} onMouseLeave={setApiHover.bind(null, false)} className={`absolute px-[6px] py-[4px] xs:px-[10px] xs:py-[4px] lg:px-[12px] lg:py-[6px] bg-[rgba(61,28,142,0.2)] hover:bg-[rgba(61,28,142,0.4)] cursor-pointer text-[rgba(255,255,255,1)] flex  flex-center font-bold rounded-3xl 
          ${showTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 'right-[62px] hover:-translate-x-[4px] xs:right-[81px] xs:hover:-translate-x-[7px] sm:right-[87px] sm:hover:-translate-x-[7px] md:right-[95px] md:hover:-translate-x-[9px] lg:right-[120px] lg:hover:-translate-x-[10px] top-[12px] md:top-[15px] text-[4px]  xs:text-[8px] sm:text-[8px] md:text-[10px] lg:text-[12px]' : 'right-[10px] top-[10px] md:right-[14px] md:top-[14px] lg:right-[15px] lg:top-[15px] text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px]'} after:content-[""] after:w-full after:h-full after:absolute after:left-0 after:top-0 after:[box-shadow:0px_0px_12px_3px_rgba(255,_249,_228,_0.6)] after:animate-pulse after:rounded-3xl`}>
            <div className='whitespace-nowrap flex justify-center items-center'>
              <span className={`[transition:width_0.4s_ease,opacity_0.3s_ease] ${apiHover ? 'opacity-100 visible' : 'opacity-0 invisible w-0'}`}>{t('WALLET_POPUP_DASHBOARD')}</span>
              <span className={`[transition:width_0.4s_ease,opacity_0.3s_ease] ${apiHover ? 'opacity-0 invisible w-0' : 'opacity-100 visible'}`}>{t('SUBSCRIPTION_API_QUEUE') + (businessPriceIndex < 2 ? '1' : businessPriceIndex < 4 ? '2' : '3')}</span>
            </div>
          </div>
        </Restricted>
        <div className='text-[14px] xs:text-[16px] sm:text-[18px] md:text-[20px] lg:text-[24px] leading-[16px] sm:leading-[18px] md:leading-[20px] lg:leading-[24px] pt-[14px] pb-[18px] sm:pt-[14px] sm:pb-[20px]  md:pt-[14px] md:pb-[24px] lg:pt-[16px] lg:pb-[26px] text-white'>
          {showTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 && <span className='absolute text-[rgba(255,255,255,0.6)] text-[10px] sm:text-[11px] md:text-[12px] lg:text-[15px] translate-y-[16px] sm:translate-y-[18px] md:translate-y-[22px] lg:translate-y-[28px] '>${BusinessPrice[businessPriceIndex]} / month thereafter</span>}
          <span className='relative pr-1 xs:pr-3 h-fit inline-block'>
            <span className='text-subscription-price font-bold'>{yearChecked ? BusinessPrice[businessPriceIndex] * 0.8 : showTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? Math.round(BusinessPrice[businessPriceIndex] * 0.5) : BusinessPrice[businessPriceIndex]}</span>
            <img className='absolute -right-1 top-0 -translate-y-[50%] w-[6px] xs:w-[8px] sm:w-[10px] h-auto' src={subPrice} alt="$" />
          </span>
          {/* {!yearChecked && subscriptionsInfo.plan_level!=='Business'  && <span className='absolute bg-[linear-gradient(96.13deg,#FB5F1F_-4.12%,#F7AF31_102.42%)] text-[8px] leading-[8px] sm:text-[10px] sm:leading-[10px] px-[6px] sm:px-[5px] md:px-[6px] py-[3px] rounded-md translate-x-1 -translate-y-2 sm:-translate-y-2 md:-translate-y-2 lg:-translate-y-1 '>70% OFF</span>} */}
          <span className={`text-subscription-price-sm`}>/ {showTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 'first mo.' : t('SUBSCRIPTION_MONTH')}</span>
          <span onMouseEnter={() => { setCreditHover(true) }} onMouseLeave={() => { setCreditHover(false) }} className='relative top-[-4px] ml-[5px] sm:ml-[5px] lg:ml-[8px] bg-[rgba(240,234,255,1)] rounded px-1 py-[3px] lg:px-2 lg:py-[6px]  text-[6px] xs:text-[10px] sm:text-[10px] md:text-xs text-[rgba(148,102,242,1)]'>
            <span>
              {!creditHover ? '~' + Math.floor(BusinessPrice[businessPriceIndex] / 1.5 * 1.3 * 2 / 0.5) : '$' + Math.floor(((yearChecked ? BusinessPrice[businessPriceIndex] * 0.8 : showTrial && (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? BusinessPrice[businessPriceIndex] * 0.5 : BusinessPrice[businessPriceIndex]) / (BusinessPrice[businessPriceIndex] / 1.5 * 1.3)) * 100) / 200}
            </span>
            <span>{!creditHover ? ' Assets' : `/${t('WALLET_CREDIT')}`}</span>
          </span>

        </div>

        <span className='text-subscription-price-sm leading-[12px] sm:leading-[14px] md:leading-[16px] text-[#F3F3F3] w-full flex flex-row items-center whitespace-nowrap'>
          <span>{BusinessPrice[businessPriceIndex] / 1.5 * 1.3 * 2}</span>
          <span>&nbsp;{t('SUBSCRIPTION_CREDIT_MONTHLY')}</span>
        </span>

        <Temperature
          sliderVal={businessPriceIndex}
          setSliderVal={setBusinessPriceIndex}
        />
      </div>
      <div className='w-full h-full flex flex-col p-4 overflow-scroll'>
        <div className='w-full flex flex-col rounded-lg bg-[rgba(255,255,255,0.03)] p-4 gap-2'>
          {LangBusinessBeneFits.map((item, index) => {
            return (
              <div className='text-[12px] md:text-[14px] text-[rgba(242,242,242,1)] flex w-full gap-2 items-start' key={index}>
                <img className='w-[14px] h-[14px]' src={checkIcon_2} alt="√" />
                <span className='text-left'>{item}</span>
              </div>
            )
          })}
        </div>

      </div>
      <div className='p-[16px]'>
        <div
          onClick={loading ? () => { } : handlerChoosePlan.bind(null, 'Business')}
          className={`[transition:all_0.3s_ease] text-[14px] md:text-[16px] lg:text-[18px] w-full h-[54px] bg-[linear-gradient(272.06deg,#887BCA_0%,#6655BC_100%)] flex-center text-[rgba(255,255,255,1)] font-bold rounded-xl ${loading ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-[linear-gradient(272.06deg,#B166FB_0%,#795EFC_50%,#8067FD_100%)]'}`}>{!isCreatorOrAbove() ? t('SUBSCRIPTION_BTN_TIPS_2_1') : t('SUBSCRIPTION_BTN_TIPS_2_2')}</div>
      </div>
    </div>
  )
}

const EnterpriseTier = ({ yearChecked, setShowSubscribe, loading }) => {

  // const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  const setIsFeedbackModalOpen = useSetRecoilState(isFeedbackModalOpenAtom);
  const { t } = useTranslation();


  const handlerTalkWithUs = () => {
    setShowSubscribe(false)
    setIsFeedbackModalOpen(true)
  }

  const LangEnterpriseBeneFits = [
    t('SUBSCRIPTION_ENT_BENE_FITS_1'),
    t('SUBSCRIPTION_ENT_BENE_FITS_2'),
    t('SUBSCRIPTION_ENT_BENE_FITS_3'),
    t('SUBSCRIPTION_ENT_BENE_FITS_4'),
    t('SUBSCRIPTION_ENT_BENE_FITS_5')
  ]

  return (
    <div className={`w-[177px]  xs:w-[232px]  sm:w-[254px]   md:w-[290px]  lg:w-[349px]  xl:w-[348px]  bg-[linear-gradient(180deg,#645588_33.24%,#484848_100%)] flex flex-col rounded-2xl
    h-[275px] xs:h-[360px] sm:h-[395px] md:h-[451px] lg:h-[542px] xl:h-[541px]`}>
      {/* 'h-[165px] xs:h-[218px] sm:h-[240px] md:h-[275px] lg:h-[323px] xl:h-[325px]' unlimit存在时的高度设置*/}
      <div className={`relative shrink-0 w-full flex flex-col items-start px-[16px] sm:px-[22px] md:px-[28px] lg:px-[32px] py-[8px] sm:py-[8px] md:py-[12px] lg:py-[16px] rounded-t-2xl bg-[linear-gradient(0deg,rgba(0,0,0,0.1),rgba(0,0,0,0.1)),linear-gradient(115.01deg,#57487C_9.59%,#59387B_42.61%,#462B87_66.63%,#523560_76.88%,#3E2E64_101.49%)]
      h-[124px] sm:h-[134px]  md:h-[154px] lg:h-[174px]`}>
        {/* 'h-[68px] sm:h-[74px] md:h-[85px] lg:h-[96px]' unlimit存在时的高度设置*/}
        {/* {subscriptionsInfo.plan_level === 'Enterprise' &&
          (
            <div className='bg-[rgba(255,255,255,0.2)] text-[rgba(255,255,255,1)] flex-nowrap absolute right-[10px] top-[10px] flex-center w-max text-[12px] sm:text-[14px] font-bold px-[8px] py-[6px] md:px-[14px] md:py-[10px] [border-radius:4px_16px_4px_4px]'>
              Your Plan
            </div>
          )} */}
        <span className='font-bold text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] text-white'>{t('SUBSCRIPTION_PLAN_ENTERPRISE')}</span>
        <div className='text-[16px] sm:text-[18px] md:text-[20px] lg:text-[24px] text-white'>
          <span className='pr-5 h-fit inline-block'>
            <span className='text-[20px] md:text-[24px] lg:text-[30px] font-bold'>{t('SUBSCRIPTION_LET_TALK')}</span>
          </span>
        </div>
      </div>
      <div className='w-full h-full flex flex-col p-4 pb-1 overflow-scroll'>
        <div className='w-full flex flex-col rounded-lg overflow-scroll bg-[rgba(255,255,255,0.03)] p-4 gap-2'>
          {LangEnterpriseBeneFits.map((item, index) => {
            return (
              <div className='text-[12px] md:text-[14px] text-[rgba(242,242,242,1)] flex  w-full gap-2  items-start' key={index}>
                <img className='w-[14px] h-[14px]' src={checkIcon_2} alt="√" />
                <span className='text-left'>{item}</span>
              </div>
            )
          })}
        </div>
      </div>
      <div className='p-[16px]'>
        <div
          onClick={loading ? () => { } : handlerTalkWithUs}
          className={`[transition:all_0.3s_ease] text-[14px] md:text-[16px] lg:text-[18px] w-full h-[54px] bg-[linear-gradient(92.11deg,#6959BA_1.08%,#874AEA_98.92%)] flex-center text-[rgba(255,255,255,1)] font-bold rounded-xl ${loading ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-[linear-gradient(272.06deg,#B166FB_0%,#795EFC_50%,#8067FD_100%)]'}`}>{t('SUBSCRIPTION_BTN_TIPS_3')}&nbsp;<FaArrowRight /></div>
      </div>
    </div>
  )
}

const Unlimited = ({ yearChecked, handlerChoosePlan, loading, setUnlimitPlan, renewalInfo }) => {
  const subscriptionsUnlimitInfo = renewalInfo
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const [subUnlimitedAnimation, setSubUnlimitedAnimation] = useRecoilState(subUnlimitedAnimationAtom)
  const timeRef = useRef(null)
  const hourArr = [...Array(25).keys()].map(i => 24 - i);
  const minArr = [...Array(61).keys()].map(i => 60 - i);
  const secondsArr = [...Array(61).keys()].map(i => 60 - i);
  const logInfo = useRecoilValue(logInfoAtom)
  const currentTime = new Date()
  const { t } = useTranslation();
  const [timeStamp, setTimeStamp] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [showFire, setShowFire] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false);
  const [unlimitInfoInit, setUnlimitInfoInit] = useState(false)
  const [unlimitnum, setUnlimitnum] = useState(false)

  useEffect(() => {
    if (subscriptionsUnlimitInfo.quota >= 0) {
      setTimeout(() => {
        setUnlimitInfoInit(true)
        setSubUnlimitedAnimation(true)
        setTimeout(() => {
          if (subscriptionsUnlimitInfo.quota < 5) {
            setShowFire(true)
          }
          setUnlimitnum(true)
        }, 550)
      }, 300)
    }
  }, [subscriptionsUnlimitInfo])

  const computeTimeStamp = () => {
    const totalSeconds = currentTime.getHours() * 3600 + currentTime.getMinutes() * 60 + currentTime.getSeconds();
    const Time = 24 * 60 * 60 - totalSeconds
    const totalRemain = Time + subscriptionsUnlimitInfo.reset_remain;
    const hours = Math.floor(totalRemain / 3600);
    const minutes = Math.floor((totalRemain % 3600) / 60);
    const seconds = totalRemain % 60;
    setTimeStamp({ hours: (hours > 24 || hours < 0 ? 0 : hours), minutes: (minutes > 60 || minutes < 0 ? 0 : minutes), seconds: (seconds > 60 || seconds < 0 ? 0 : seconds) });
  };

  useEffect(() => {
    computeTimeStamp();
    if (timeRef.current) {
      clearInterval(timeRef.current);
    }
    timeRef.current = setInterval(() => {
      setTimeStamp((preTime) => {
        let { hours, minutes, seconds } = preTime;
        if (seconds > 0) {
          seconds--;
        } else {
          if (minutes > 0) {
            minutes--;
            seconds = 59;
          } else {
            if (hours > 0) {
              hours--;
              minutes = 59;
              seconds = 59;
            } else {
              clearInterval(timeRef.current);
            }
          }
        }
        return { hours, minutes, seconds };
      })
    }, 1000)

    return () => {
      if (timeRef.current) {
        clearInterval(timeRef.current)
      }
    }
  }, [subscriptionsUnlimitInfo])

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div className='relative text-white text-primary w-[177px] h-[104px] xs:w-[232px] xs:h-[135px] sm:w-[254px] sm:h-[147px] md:w-[290px] md:h-[167px] lg:w-[349px] lg:h-[210px] xl:w-[348px] xl:h-[207px] bg-[linear-gradient(284.98deg,#292637_0%,#353535_100%)] flex flex-col items-center rounded-2xl
    before:z-[1] before:[-webkit-mask-image:linear-gradient(red,red),linear-gradient(red,red)] before:[-webkit-mask-clip:padding-box,content-box] before:absolute before:box-border before:content-[""] before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:block before:[border-radius:inherit] before:p-px before:bg-[linear-gradient(104.72deg,rgba(110,110,255,0.6)_0.37%,rgba(214,78,255,0.2)_100%)] before:bg-clip-padding before:[mask-composite:exclude]'>
      <div className='absolute z-[999] whitespace-nowrap flex flex-row items-center justify-between px-2 md:px-3 text-[5px] xs:text-[7px] sm:text-[9px] md:text-[10px] lg:text-[12px] w-[97%] h-[16.83px] xs:h-[22.1px] sm:h-[24.14px] md:h-[27.54px] lg:h-[34.85px] xl:h-[34.34px] top-0 -translate-y-[50%] bg-[rgba(121,97,255,1)] rounded-[20px]'>
        <div className={`aspect-square absolute -ml-[5px] h-[55%] [transition:all_0.3s_ease] ${showFire ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
          <img className='w-full h-full scale-[150%]' src={fireIcon} alt='fireIcon' />
        </div>
        <div className={`h-full w-auto flex relative flex-row items-center pointer-events-none [transition:all_0.3s_ease] ${showFire ? 'ml-[4%]' : 'ml-0'}`}>
          {t('SUBSCRIPTION_PLAN_UNLIMITED_HEADER_TIP_1')}
          <div className={`w-[15px] h-[15px] sm:w-[16px] sm:h-[16px] md:w-[18px] md:h-[18px] lg:w-[23px] lg:h-[23px] xl:w-[22px] xl:h-[22px] relative mx-[2px] font-bold bg-[rgba(0,0,0,0.5)] flex items-center rounded-md overflow-hidden`}>

            <div
              className={`w-full h-auto absolute top-0 xs:-top-[4.7%] lg:top-0 flex flex-col items-center [transition:all_0.5s_ease] ${subUnlimitedAnimation ? '-translate-y-[50%]' : unlimitInfoInit ? '-translate-y-[50%]' : 'translate-y-[0%]'}`}>{[subscriptionsUnlimitInfo.quota + 1, subscriptionsUnlimitInfo.quota].map((item, index) => {
                return (
                  <div className={`text-[8px] xs:text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] 
                  ${subscriptionsUnlimitInfo.quota < 5 ? '[background-image:linear-gradient(180deg,#FFD11B_36.27%,#FF4800_133.6%)] text-[transparent] [background-clip:text] [-webkit-background-clip:text]' : 'text-white [background-image:none]'}
                  ${unlimitnum ? 'animate-sub-unlimitednum' : ''}`} key={index}>
                    {subscriptionsUnlimitInfo.quota < 0 ? '?' : item}
                  </div>
                )
              })}</div>
            {/* <span className={`${showFire ? '[background-image:linear-gradient(180deg,#FFD11B_36.27%,#FF4800_133.6%)] text-[transparent] [background-clip:text] [-webkit-background-clip:text]':'text-white [background-image:none]'}`}>{subscriptionsUnlimitInfo.quota}</span> */}
          </div> {t('SUBSCRIPTION_PLAN_UNLIMITED_HEADER_TIP_2')}
        </div>
        {logInfo && (

          <div className='h-full flex relative flex-row items-center pointer-events-none'>{t('SUBSCRIPTION_PLAN_UNLIMITED_HEADER_TIP_3')}
            <div className='relative w-[13px] h-[13px] sm:w-[15px] sm:h-[16px] md:w-[16px] md:h-[17px] lg:w-[21px] lg:h-[21px] xl:w-[20px] xl:h-[20px] ml-[2px] bg-[rgba(0,0,0,0.5)] rounded-md overflow-hidden'>
              <div style={{ transform: `translateY(${-(24 - timeStamp.hours) * (1 / 25) * 100}%)` }}
                className={`w-full h-auto absolute flex flex-col items-center [transition:all_0.3s_ease]`}>{hourArr.map((item, index) => {
                  return (
                    <div className='font-bold relative rounded-md w-full h-[13px] sm:h-[16px] md:h-[17px] lg:h-[21px] xl:h-[20px] ' key={index}>
                      <span className='absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] text-[8px] sm:text-[8px] md:text-[9px] lg:text-[12px] leading-[8px] sm:leading-[9px] lg:leading-[12px] [text-shadow:0px_2px_6px_rgba(255,255,255,0.6)]'>{String(item).padStart(2, '0')}</span>
                    </div>
                  )
                })}</div>
            </div>:<div className='relative w-[13px] h-[13px] sm:w-[15px] sm:h-[16px] md:w-[16px] md:h-[17px] lg:w-[21px] lg:h-[21px] xl:w-[20px] xl:h-[20px] bg-[rgba(0,0,0,0.5)] rounded-md overflow-hidden'>
              <div style={{ transform: `translateY(${-(60 - timeStamp.minutes) * (1 / 61) * 100}%)` }}
                className={`w-full h-auto absolute flex flex-col items-center [transition:all_0.3s_ease]`}>{minArr.map((item, index) => {
                  return (
                    <div className='font-bold relative rounded-md w-full h-[13px] sm:h-[16px] md:h-[17px] lg:h-[21px] xl:h-[20px] ' key={index}>
                      <span className='absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] text-[8px] sm:text-[8px] md:text-[9px] lg:text-[12px] leading-[8px] sm:leading-[9px] lg:leading-[12px] [text-shadow:0px_2px_6px_rgba(255,255,255,0.6)]'>{item === 60 ? '00' : String(item).padStart(2, '0')}</span>
                    </div>
                  )
                })}</div>
            </div>:<div className='relative w-[13px] h-[13px] sm:w-[15px] sm:h-[16px] md:w-[16px] md:h-[17px] lg:w-[21px] lg:h-[21px] xl:w-[20px] xl:h-[20px]  mr-[2px] bg-[rgba(0,0,0,0.5)] rounded-md overflow-hidden'>
              <div style={{ transform: `translateY(${-(60 - timeStamp.seconds) * (1 / 61) * 100}%)` }}
                className={`w-full h-auto absolute flex flex-col items-center [transition:all_0.3s_ease]`}>{secondsArr.map((item, index) => {
                  return (
                    <div className='font-bold relative rounded-md w-full h-[13px] sm:h-[16px] md:h-[17px] lg:h-[21px] xl:h-[20px] ' key={index}>
                      <span className='absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] text-[8px] sm:text-[8px] md:text-[9px] lg:text-[12px] leading-[8px] sm:leading-[9px] lg:leading-[12px] [text-shadow:0px_2px_6px_rgba(255,255,255,0.6)]'>{item === 60 ? '00' : String(item).padStart(2, '0')}</span>
                    </div>
                  )
                })}</div>
            </div></div>
        )}
      </div>


      <div className='absolute w-full h-full flex flex-col z-[2] px-4'>
        <div className='shrink-0 w-full h-[26%] md:h-[28%] lg:h-[30%] flex flex-row items-end relative'>
          <div className='h-full aspect-square flex justify-center items-center relative'>
            <img className={`[filter:drop-shadow(0px_2px_4px_rgba(157,108,255,0.6))] w-full h-full scale-[145%] absolute top-0 translate-y-[32%] ${isSafari ? 'opacity-0' : isLoaded ? 'opacity-100' : 'opacity-0'}`} onLoad={handleImageLoad} src={unlimitedIcon} alt='unlimitedIcon' />
            <img className={`w-full h-full absolute translate-y-[32%] scale-y-[110%] scale-x-[145%] ${isSafari ? 'opacity-100' : !isLoaded ? 'opacity-100' : 'opacity-0'}`} src={unlimitedInitIcon} />
          </div>
          <span className='mb-[0.5%] text-[15px] xs:text-[17px] md:text-[21px] lg:text-[27px] leading-[17px] md:leading-[21px] lg:leading-[27px] font-bold'>{t('SUBSCRIPTION_PLAN_UNLIMITED')}</span>
          <Restricted to="api.view">
            <div className={`absolute right-0 my-auto mb-0 md:mb-[1%] px-[6px] py-[3px] xs:px-[10px] xs:py-[3px] lg:px-[12px] lg:py-[5px] bg-[rgba(136,136,136,0.15)] text-[rgba(255,255,255,1)] flex flex-center rounded-3xl`}>
              <div className='whitespace-nowrap flex justify-center items-center text-[6px] lg:text-[12px] md:text-[10px] xs:text-[8px] sm:text-[10px]'>
                <span className={`opacity-100 visible`}>{t('SUBSCRIPTION_API_QUEUE') + '3'}</span>
              </div>
            </div>
          </Restricted>
        </div>
        <div className='w-full px-4 h-[30%] text-[6px] xs:text-[8px] md:text-[10px] lg:text-[12px] my-[5px] xs:my-[8px] bg-[rgba(72,67,91,1)] rounded-xl flex flex-col justify-center items-start'>
          <div className='flex flex-row items-center'>
            <span className='h-[5px] aspect-square rounded-full bg-[rgba(123,123,123,1)] mr-[8px]'></span>
            <span
              className='font-bold relative after:absolute after:content-["$"] after:right-0 after:top-0 after:-translate-y-[10%] after:translate-x-[110%] after:text-[5px] xs:after:text-[9px]'>300</span>
            <span
              className='text-[rgba(255,255,255,0.6)] ml-[5px]'>&nbsp;/ {t('SUBSCRIPTION_MONTH')}</span>
            <span
              className='font-bold relative after:absolute'>&nbsp; {t('SUBSCRIPTION_PLAN_CHANGE_UNLIMIT_TIP')}</span>
          </div>
          <div className='flex flex-row items-center'>
            <span className='h-[5px] aspect-square rounded-full bg-[rgba(123,123,123,1)] mr-[8px]'></span>
            <span className='font-bold'>{t('SUBSCRIPTION_PLAN_UNLIMIT_TIP1')}</span>
            <span className='text-[rgba(255,255,255,0.6)] ml-[4px]'>{t('SUBSCRIPTION_PLAN_UNLIMIT_TIP2')}</span>
          </div>
          {/*<div className='flex flex-row items-center'>*/}
          {/*  <span className='h-[5px] aspect-square rounded-full bg-[rgba(123,123,123,1)] mr-[8px]'></span>*/}
          {/*  /!*<span className='font-bold whitespace-nowrap'>{t('SUBSCRIPTION_PLAN_CHANGE_UNLIMIT_TIP')}</span>*!/*/}
          {/*</div>*/}
        </div>
        <div
          onClick={loading ? () => { } : handlerChoosePlan.bind(null, 'Unlimited')}
          className={`w-full h-[25%] relative rounded-2xl flex items-center justify-center  p-[6px] cursor-pointer overflow-hidden [box-shadow:0px_0px_12px_0px_rgba(163,117,255,1)] bg-[linear-gradient(253.53deg,rgba(149,222,255,0.3)_-0.93%,rgba(134,127,255,0.3)_35.75%,rgba(162,96,255,0.3)_126.42%)]
        before:pointer-events-none before:absolute before:w-[110%] before:aspect-square  before:-left-[2] before:-top-[300%] before:bg-[linear-gradient(225deg,#95DEFF_10%,#867FFF_52.9%,#A260FF_147.66%)] before:z-[-2] before:rounded-full before:animate-sub-unlimited
        after::pointer-events-none after:absolute after:w-[calc(100%-4px)] after:h-[calc(100%-4px)] after:z-[-1] after:rounded-[14.5px] after:bg-[linear-gradient(284.98deg,#292637_0%,#353535_100%)]`}>
          <div className='w-full h-full font-bold gap-[2px] text-[10px] sm:text-[12px] md:text-[14px] lg:text-[18px] flex justify-center items-center bg-[linear-gradient(93deg,#95DEFF_-53.1%,#867FFF_21.99%,#A260FF_102.72%)] rounded-xl'>
            <img className='[filter:drop-shadow(0px_4px_4px_rgba(255,255,255,0.4))] h-[50%] aspect-square' src={flashIcon} alt='flashIcon' />
            <span className='[text-shadow:0px_4px_4px_rgba(255,255,255,0.4)]'>Select this plan</span>
          </div>
        </div>
      </div>
    </div>
  )
}

const EducationPage = ({ setOpenEduHover, setFetchver }) => {
  const [role, setRole] = useState(false)
  const [reg1, setReg1] = useState(false)
  const [reg2, setReg2] = useState(false)
  const [institution, setInstitution] = useState(false)
  const [email, setEmail] = useState(false)
  const [code, setCode] = useState(false)
  const [codeSend, setCodeSend] = useState(false)
  const [error, setError] = useState([])
  const [countdown, setCountdown] = useState(50)
  const [iframe, setIframe] = useState({ type: false, src: false })
  let interval = useRef(null)
  const tip = useTips();
  const roleMeg = [
    'Student',
    'Educator',
  ]

  const closeEdu = (e) => {
    var myDiv = document.getElementById('edu');
    if (myDiv.contains(e.target)) {
      return
    } else {
      setOpenEduHover(false)
    }
  }

  const selectIns = (e) => {
    if (error.some(value => value === 'institution')) {
      setError((old) => old.filter(value => value != 'institution'))
    }
    if (e.target.value) {
      setInstitution(e.target.value)
    } else {
      setInstitution(false)
    }
  }

  const ChangeEmail = (e) => {
    if (error.some(value => value === 'email')) {
      setError((old) => old.filter(value => value != 'email'))
    }
    if (e.target.value) {
      setEmail(e.target.value)
    } else {
      setEmail(false)
    }
  }

  const ChangeCode = (e) => {
    if (error.some(value => value === 'code')) {
      setError((old) => old.filter(value => value != 'code'))
    }
    if (e.target.value) {
      setCode(e.target.value)
    } else {
      setCode(false)
    }
  }

  const SendCode = async () => {
    if (email) {
      const res = await sendEduEmail(email)
      if (res && !res.data?.error) {
        setCodeSend(true)
      } else {
        tip({
          type: 'error',
          content: t('TIP_ERR_SUB_EDU_EMAIL'),
        });
      }

    }
  }

  useEffect(() => {
    if (codeSend) {
      let num = 60
      setCountdown(num)
      interval = setInterval(() => {
        if (num > 0) {
          num--
          setCountdown((old) => old - 1)
        } else if (num === 0) {
          clearInterval(interval)
          setCodeSend(false)
        }
      }, 1000)
    }
  }, [codeSend])

  const Submit = async () => {
    if (role && institution && email && code && reg1 && reg2 && reg1 === 1 && reg2 === 1) {
      const data = {
        role: roleMeg[role - 1],
        institution: institution
      }
      const res = await EduSubmit(email, code, data)
      if (res && res.data) {
        if (res.data?.error) {
          tip({
            type: 'error',
            content: t('TIP_ERR_SUB_EMAIL_INVALID'),
          });
          setError((old) => [...old, 'code'])
          return
        } else {
          setFetchver(true)
          setOpenEduHover(false)
        }
      }
    } else {
      if (reg1 === 2 || reg2 === 2) {
        tip({
          type: 'error',
          content: t('TIP_ERR_SUB_ACC_REG'),
        });
      } else {
        tip({
          type: 'error',
          content: t('TIP_ERR_SUB_COMPLETE_FORM'),
        });
      }
      if (!role) {
        setRole(false)
        setError((old) => [...old, 'role'])
      } if (!institution) {
        setError((old) => [...old, 'institution'])
      } if (!email) {
        setError((old) => [...old, 'email'])
      } if (!code) {
        setError((old) => [...old, 'code'])
      } if (!reg1 || reg1 === 2) {
        setReg1(false)
        setError((old) => [...old, 'reg1'])
      } if (!reg2 || reg2 === 2) {
        setReg2(false)
        setError((old) => [...old, 'reg2'])
      }
    }
  }

  return (
    <div className='fixed w-[100vw] h-[100vh] left-0 top-0 bg-[#00000080] z-30 flex items-center justify-center' onClick={closeEdu} >
      <div id='edu' className='text-[#2D2D2D] text-[Arial] bg-white rounded-lg py-4 flex flex-col w-[420px] items-center'>
        <Iframe iframe={iframe} setiframe={setIframe} />
        <span className='font-bold text-xl'>Education</span>
        <span className='text-sm text-[#909090] leading-4 w-[85%]'>Part of a K12 or Higher Education Institution? Verify your education email.</span>
        <div className='text-left w-[90%] mt-3 flex flex-col gap-1'>
          <span className='text-sm font-bold'>Are you a student or educator?</span>
          <div className='w-[100%] flex flex-row text-sm'>
            {roleMeg.map((item, index) => {
              return (
                <div key={index} className={`w-[30%] flex flex-row items-center gap-[0.4rem] cursor-pointer`} onClick={() => {
                  if (error.some(value => value === 'role')) {
                    setError((old) => old.filter(value => value != 'role'))
                  }
                  setRole(index + 1)
                }}>
                  <span className={`block relative aspect-square h-[50%] border-[#C6C6C6] border rounded-full ${error.some(value => value === 'role') && 'border-[#FF3636]'} ${role === index + 1 && 'after:left-[10%] after:top-[10%] after:absolute after:w-[80%] after:h-[80%] border-[#0085f2] after:bg-[#0085f2] after:rounded-full'}`}></span>
                  {item}
                </div>
              )
            })}
          </div>
          <span className='text-sm font-bold'>What type of institution do you attend or work for?</span>
          <select className={`w-[100%] h-10 text-sm px-2 border-[#D4D4D4] border rounded-md outline-none ${error.some(value => value === 'institution') && 'border-[#FF3636]'} focus:border-[#628EFF] `} onChange={selectIns}>
            {['', 'K12', 'Higher Education', 'Online Program'].map((item, index) => {
              return (
                <option key={index}>
                  {item}
                </option>
              )
            })}
          </select>
          <span className='text-sm font-bold'>Email</span>
          <div className={`w-[100%] h-10 text-sm flex flex-row px-2 border-[#D4D4D4] border rounded-md ${error.some(value => value === 'email') && 'border-[#FF3636]'}`}>
            <input className='w-[75%] h-[100%]' onChange={ChangeEmail} />
            <button className={`w-[25%] h-[100%] flex justify-center items-center  text-sm text-[#4A00E0] ${codeSend ? 'translate-x-3  cursor-default' : 'translate-x-0'}`} onClick={codeSend ? () => { } : SendCode}>{codeSend ? countdown : 'Send Code'}</button>
          </div>
          <span className='text-sm font-bold'>Code</span>
          <div className={`w-[100%] h-10 px-2 text-sm border-[#D4D4D4] border rounded-md ${error.some(value => value === 'code') && 'border-[#FF3636]'}`}><input className='w-[100%] h-[100%]' onChange={ChangeCode} /></div>
          <div className='leading-4 text-sm mt-2'><span className='text-[#909090]'>The information you submit here, as well as your use of and access to the Deemos Education plan, is governed by our <span onClick={() => { setIframe({ type: 'Terms', src: '/Terms.html' }) }} className='text-[#4A00E0] cursor-pointer underline'>Terms of Service</span> and <span onClick={() => { setIframe({ type: 'Policy', src: '/Privacy.html' }) }} className='text-[#4A00E0] cursor-pointer underline'>Privacy Policy.</span></span></div>
          <div className='w-[100%] flex flex-row text-sm'>
            {['Yes, I agree', 'No, I do not agree'].map((item, index) => {
              return (
                <div key={index} className='w-[40%] flex flex-row items-center gap-[0.4rem] cursor-pointer' onClick={() => {
                  if (error.some(value => value === 'reg1')) {
                    setError((old) => old.filter(value => value != 'reg1'))
                  }
                  setReg1(index + 1)
                }}>
                  <span className={`block relative aspect-square h-[50%] border-[#C6C6C6] border rounded-full ${error.some(value => value === 'reg1') && 'border-[#FF3636]'} ${reg1 === index + 1 && 'after:left-[10%] after:top-[10%] after:absolute after:w-[80%] after:h-[80%] border-[#0085f2] after:bg-[#0085f2] after:rounded-full'}`}></span>
                  {item}
                </div>
              )
            })}
          </div>
          <div className='leading-4 text-sm mt-2'><span className='text-[#909090]'>You must retain proof of enrollment which Hyperhuman may ask for to verify your eligibility.
            If you have misrepresented your eligibility, you agree to pay Hyperhuman for any service fees that were initially waived.</span> </div>
          <div className='w-[100%] flex flex-row text-sm'>
            {['Yes, I agree', 'No, I do not agree'].map((item, index) => {
              return (
                <div key={index} className='w-[40%] flex flex-row items-center gap-[0.4rem] cursor-pointer' onClick={() => {
                  if (error.some(value => value === 'reg2')) {
                    setError((old) => old.filter(value => value != 'reg2'))
                  }
                  setReg2(index + 1)
                }}>
                  <span className={`block relative aspect-square h-[50%] border-[#C6C6C6] border rounded-full ${error.some(value => value === 'reg2') && 'border-[#FF3636]'} ${reg2 === index + 1 && 'after:left-[10%] after:top-[10%] after:absolute after:w-[80%] after:h-[80%] border-[#0085f2] after:bg-[#0085f2] after:rounded-full'}`}></span>
                  {item}
                </div>
              )
            })}
          </div>
          <button onClick={Submit} className='w-[100%] bg-[#4A00E0] text-white mt-2 py-2 text-lg border-transparent border rounded-xl hover:bg-white hover:text-[#4A00E0] hover:border-[#4A00E0]'>Submit</button>
        </div>
      </div>
    </div>
  )
}

const SubscriptionManagement = () => {
  const tip = useTips();
  const { t } = useTranslation();
  // const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  const handlerOpenManagement = async () => {
    try {
      const res = await getDashBoardLink()
      if (res?.data?.error) {
        trackEvent('Subscribe - Manage Subscription: Open Failed')
        throw res.data.error
      }
      if (res?.data?.url) {
        trackEvent('Subscribe - Manage Subscription: Open')
        const newPage = res.data.url
        const link = document.createElement('a')
        link.target = '_blank'
        link.href = newPage;
        if (document.body) {
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        // window.open(res.data.url, '_blank')
      } else {
        trackEvent('Subscribe - Manage Subscription: No Subscribe')
        tip({
          type: 'error',
          content: t('TIP_ERR_SUBSCRIBE_SUB_PLAN'),
        });
      }

    } catch (error) {
      trackEvent('Subscribe - Manage Subscription: Open Failed')
      Sentry.captureException(error)
      console.error(error);
    }
  }
  return (
    <>
      <div onClick={handlerOpenManagement}
        className="absolute px-[0.4em] py-[0.2em] rounded-tl-[2px] rounded-br-[2px] rounded-tr-[2px] rounded-bl-none bg-[linear-gradient(55deg,_#FC4A1A_-19.72%,_#F7B733_105.55%)] cursor-pointer right-[3em] top-[18px] sm:top-[25px] text-sm text-primary font-bold bg-[linear-gradient(82deg,_#37FFFF_-35.27%,_#A93BFF_106.85%)] bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] z-20 hover:after:w-full after:content-[''] after:absolute after:-bottom-[2px] after:left-[0] after:bg-[linear-gradient(82deg,_#37FFFF_-35.27%,_#A93BFF_106.85%)] after:h-px after:w-[0] after:[transition:width_0.3s_ease]">
        {t('SETTINGS_USER_MANAGE_SUB')}
      </div>
    </>
  )
}

const Temperature = ({ sliderVal, setSliderVal }) => {
  const [positionValue, setPositionValue] = useState(sliderVal);
  const [resetPositionArr, setReserPositionArr] = useState([])
  const rangeRef = useRef(null);
  const knobRef = useRef(null);
  const progressRef = useRef(null);
  const realPosition = useRef(0)

  const jugementPosition = (realP) => {
    const index = resetPositionArr.findIndex(item => realP <= item)
    let realIndex = realP > (resetPositionArr[index] + resetPositionArr[index - 1]) * 0.5 ? index : index - 1
    if (realIndex < 0) {
      realIndex = 0
    } else if (realIndex > 4) {
      realIndex = 4
    }
    setPositionValue(resetPositionArr[realIndex])
    setSliderVal(realIndex)
  }

  useEffect(() => {
    if (knobRef.current && rangeRef.current) {
      const max = rangeRef.current.clientWidth - knobRef.current.clientWidth + 10
      setReserPositionArr(new Array(5).fill(0).map((_, index) => max / 4 * index))
    }
  }, [rangeRef, knobRef])

  const handleStart = (operate, e) => {
    e.stopPropagation()
    if (operate === 'mouse' && e.button !== 0) return;
    if (operate === 'touch' && e.touches.length !== 1) return;
    if (e.button !== 0) return
    knobRef.current.style.transition = 'none'
    progressRef.current.style.transition = 'none'
    const startX = operate === 'mouse' ? e.clientX : e.touches[0].clientX;
    const selfXPosition = knobRef.current.offsetLeft
    const handleMove = (e) => {
      e.stopPropagation()
      const endX = operate === 'mouse' ? e.clientX : e.touches[0].clientX;
      let diffX = selfXPosition + endX - startX
      if (diffX <= 0) {
        diffX = 0
      }
      if (diffX >= (rangeRef.current.clientWidth - knobRef.current.clientWidth + 10)) {
        diffX = (rangeRef.current.clientWidth - knobRef.current.clientWidth + 10)
      }
      setPositionValue(diffX);
      realPosition.current = diffX
    }
    const handleEnd = () => {
      knobRef.current.style.transition = '0.1s ease'
      progressRef.current.style.transition = '0.1s ease'
      jugementPosition(realPosition.current)
      if (operate === 'mouse') {
        document.removeEventListener('mousemove', handleMove);
        document.removeEventListener('mouseup', handleEnd);
      } else {
        document.removeEventListener('touchmove', handleMove);
        document.removeEventListener('touchend', handleEnd);
        document.removeEventListener('touchcancel', handleEnd);
      }
    }
    if (operate === 'mouse') {
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('mouseup', handleEnd);
    } else {
      document.addEventListener('touchmove', handleMove);
      document.addEventListener('touchend', handleEnd);
      document.addEventListener('touchcancel', handleEnd);
    }
  }

  const handleClickPosition = (e) => {
    const left = rangeRef.current.getBoundingClientRect().left
    knobRef.current.style.transition = 'none'
    progressRef.current.style.transition = 'none'
    const startX = e.clientX;
    realPosition.current = startX - left
    setPositionValue(startX - left)
    document.onmousemove = (e) => {
      e.stopPropagation()
      const endX = e.clientX;
      let diffX = startX - left + endX - startX
      if (diffX <= 0) {
        diffX = 0
      }
      if (diffX >= (rangeRef.current.clientWidth - knobRef.current.clientWidth + 10)) {
        diffX = (rangeRef.current.clientWidth - knobRef.current.clientWidth + 10)
      }
      setPositionValue(diffX);
      realPosition.current = diffX
    }
    document.onmouseup = function () {
      knobRef.current.style.transition = '0.1s ease'
      progressRef.current.style.transition = '0.1s ease'
      e.stopPropagation()
      jugementPosition(realPosition.current)
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }

  return (
    <div className="relative rounded-[10px] bg-[#eee] my-[6px] w-full"
      onPointerDown={handleClickPosition} ref={rangeRef}>
      <div className="relative rounded-[12px] bg-[#fff] w-full h-[10px] md:h-[12px] lg:h-[15px]">
        {[...Array(9)].map((_, index) => (
          <div
            style={{
              left: `${index === 0 ? 2 : index === 8 ? 98 : index * 12.5}%`,
              display: `${index % 2 === 0 ? 'block' : 'none'}`
            }}
            key={index}
            className="w-[5px] h-[5px] bg-[#b4b4b4] absolute top-2/4 -translate-y-1/2 rounded-[50%]"></div>
        ))}
        <div
          className='absolute w-[20px]  h-[20px] bg-[#4a00f4] rounded-[50%] border-[3px] border-[solid] border-[#fff] top-2/4 -translate-x-1/2 -translate-y-1/2 cursor-pointer [box-shadow:0_0_5px_2px_rgba(0,_0,_0,_0.1)]' ref={knobRef}
          style={{ left: `${positionValue}px` }}
          onMouseDown={handleStart.bind(null, 'mouse')}
          onTouchStart={handleStart.bind(null, 'touch')}
        ></div>
        <div className="bg-[#6f45d1] h-full rounded-xl"
          style={{ width: `${positionValue}px` }}
          ref={progressRef}></div>
      </div>
    </div>
  );
};

const Subscribe = () => {
  const [showSubscribe, setShowSubscribe] = useRecoilState(showSubscribeAtom)
  const [fetchver, setFetchver] = useState(false)
  const logInfo = useRecoilValue(logInfoAtom)
  const setShowLogin = useSetRecoilState(showLoginAtom);
  const [creatorPriceIndex, setCreatorPriceIndex] = useState(0)
  const [businessPriceIndex, setBusinessPriceIndex] = useState(0)
  const [planChange, setPlanChange] = useState(false)
  const [yearinfo, setYearChecked] = useRecoilState(showSubscribeTimesAtom)
  const yearChecked = yearinfo === 'yearly'
  const [currentPlan, setCurrentPlan] = useState(false)
  const [loading, setLoading] = useState(false)
  const stripeBoxRef = useRef(null)
  const upgradeRef = useRef(null)
  const upPageRef = useRef(null)
  const tip = useTips(null)
  const [myPlanHover, setMyPlanHover] = useState(false)
  const [openEduHover, setOpenEduHover] = useState(false)
  const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  const setIsFeedbackModalOpen = useSetRecoilState(isFeedbackModalOpenAtom);
  const [subscriptionsUnlimitInfo, setSubscriptionsUnlimitInfo] = useRecoilState(subscriptionsUnlimitInfoAtom)
  const { t } = useTranslation();
  const { isCreator } = useContext(PermissionContext);
  const [previousUrl, setPreviousUrl] = useState(window.location.pathname);
  const animationRef = useRef(null)

  // useEffect(() => {
  //   console.log('showSubscribe', showSubscribe)
  //   if (showSubscribe) {
  //     setPreviousUrl(window.location.pathname);
  //     window.history.pushState(null, null, "/subscribe");
  //   } else {
  //     window.history.pushState(null, null, previousUrl);
  //   }
  // }, [showSubscribe]);

  useEffect(() => {
    if (showSubscribe) {
      startAnimate()
    } else {
      if (animationRef.current) {
        animationRef.current.kill()
      }
    }
    return () => {
      if (animationRef.current) {
        animationRef.current.kill()
      }
    }
  }, [showSubscribe])

  const handlerClose = (e) => {
    if (stripeBoxRef.current && stripeBoxRef.current.contains(e.target)) return
    if (upgradeRef.current && upgradeRef.current.contains(e.target)) return

    setCreatorPriceIndex(0)
    setBusinessPriceIndex(0)
    setYearChecked('yearly')
    setShowSubscribe(false)
  }

  const handlerCloseUpgrade = (e) => {
    if (upPageRef.current && upPageRef.current.contains(e.target)) return
    setPlanChange(false)
  }

  const handlerChoosePlan = async (taget) => {
    if (!logInfo) {
      setShowLogin(true);
      return;
    }
    if (subscriptionsInfo?.active) {
      if (taget === 'Unlimited') {
        if (subscriptionsUnlimitInfo.quota === 0) {
          tip({
            type: 'primary',
            content: t('TIP_PRIMARY_SUBSCRIBE_UNLIMIT_QUOTA'),
          });
          return;
        }
        if (subscriptionsInfo.plan_level === 'Unlimited') {
          const startDate = new Date(subscriptionsInfo?.start_time);
          const endDate = new Date(subscriptionsInfo?.end_time);
          const diffTime = Math.abs(endDate - startDate);
          const diffMonths = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 30.44));
          if (diffMonths > 1) {
            tip({
              type: 'primary',
              content: t('TIP_PRIMARY_SUBSCRIBE_PLAN'),
            });
            setShowSubscribe(false)
            setIsFeedbackModalOpen(true)
            return;
          }
          tip({
            type: 'primary',
            content: t('TIP_PRIMARY_SUB_CURRENT_PLAN'),
          });
          return;
        } else {
          setCurrentPlan(taget)
          setPlanChange(true)
          return;
        }
      } else {
        if (subscriptionsInfo.plan_level === 'Unlimited') {
          tip({
            type: 'primary',
            content: t('TIP_PRIMARY_SUBSCRIBE_PLAN'),
          });
          setShowSubscribe(false)
          setIsFeedbackModalOpen(true)
          return;
        }
      }
      const pre = Number(isCreator() ? subscriptionsInfo.plan_price : (subscriptionsInfo.plan_price / 1.5 * 1.3 * 2)) * (subscriptionsInfo.plan_yearly ? 12 : 1)
      const current = Number(taget === 'Creator' ? CreatorPrice[creatorPriceIndex] : (BusinessPrice[businessPriceIndex] / 1.5 * 1.3 * 2)) * (yearChecked ? 12 : 1)
      if (current > pre) {
        setCurrentPlan(taget)
        setPlanChange(true)
      } else if (subscriptionsInfo.plan_level === taget && current === pre) {
        tip({
          type: 'primary',
          content: t('TIP_PRIMARY_SUB_CURRENT_PLAN'),
        });
      } else {
        tip({
          type: 'primary',
          content: t('TIP_PRIMARY_SUBSCRIBE_PLAN'),
        });
        setShowSubscribe(false)
        setIsFeedbackModalOpen(true)
      }
      return
      // setShowSubscribe(false)
    } else {
      setLoading(true)
      ReactGA.event({
        category: 'ui_click',
        action: 'subscribe',
        label: taget
      })
      try {
        if (taget === 'Unlimited' && subscriptionsUnlimitInfo.quota === 0) {
          tip({
            type: 'primary',
            content: t('TIP_PRIMARY_SUBSCRIBE_UNLIMIT_QUOTA'),
          });
          return;
        }
        const param = {
          billing_provider: 'Stripe',
          plan_level: taget,
          plan_monthly_price: taget === 'Unlimited' ? UnlimitedPrice : taget === 'Creator' ? CreatorPrice[creatorPriceIndex] : BusinessPrice[businessPriceIndex],
          yearly: taget === 'Unlimited' ? false : yearChecked
        }
        trackEvent(`Subscribe - ${taget} - Plan: Select`, param)
        const result = await subscribeToPlan(param)
        if (result?.data?.error) {
          if (taget === 'Unlimited') {
            if (result?.data?.error === 'CUSTOMER_NOT_FOUND') {
              tip({
                type: 'error',
                content: t('TIP_PRIMARY_SUBSCRIBE_UNLIMIT_QUOTA'),
              });
            }
            setSubscriptionsUnlimitInfo(pre => {
              return ({
                quota: 0,
                reset_remain: pre.reset_remain,
              })
            }
            )
          }
          setLoading(false)
          return
        }
        if (result?.data?.url) {
          if (taget === 'Unlimited' && result.data.url === 'QUOTA_EXCEEDED') {
            setSubscriptionsUnlimitInfo(pre => {
              return ({
                quota: 0,
                reset_remain: pre.reset_remain,
              })
            }
            )
            return;
          }
          window.location.href = result?.data?.url;
        }
        setLoading(false)
      } catch (e) {
        setLoading(false)
        console.log('subscribe', e)
      }

    }

    // ReactGA.event({
    //   category: 'ui_click',
    //   action: 'subscribe',
    //   label: taget
    // })

    // const param = {
    //   billing_provider: 'Stripe',
    //   plan_level: taget,
    //   plan_monthly_price: taget === 'Creator' ? CreatorPrice[creatorPriceIndex] : BusinessPrice[businessPriceIndex],
    //   yearly: yearChecked
    // }
    // const result = await subscribeToPlan(param)
    // if (result?.data?.url) {
    //   window.location.href = result?.data?.url;
    // }
  }

  const ConfirmPlan = async () => {
    setLoading(true)
    const param = {
      billing_provider: 'Stripe',
      plan_level: currentPlan,
      plan_monthly_price: currentPlan === 'Unlimited' ? UnlimitedPrice : currentPlan === 'Creator' ? CreatorPrice[creatorPriceIndex] : BusinessPrice[businessPriceIndex],
      yearly: currentPlan === 'Unlimited' ? false : yearChecked
    }

    try {
      trackEvent(`Subscribe - ${currentPlan} - Plan: Change` , param)
      const result = await changePlan(param)
      if (result?.data?.error) {
        if (currentPlan === 'Unlimited') {
          if (result?.data?.error === 'CUSTOMER_NOT_FOUND') {
            tip({
              type: 'error',
              content: t('TIP_PRIMARY_SUBSCRIBE_UNLIMIT_QUOTA'),
            });
          }
          setSubscriptionsUnlimitInfo(pre => {
            return ({
              quota: 0,
              reset_remain: pre.reset_remain,
            })
          }
          )
          setPlanChange(false)
        } else if (result?.data?.error === 'UNSUPPORTED_OPERATION') {
          tip({
            type: 'error',
            content: t('TIP_PRIMARY_SUB_CURRENT_PLAN'),
          });
        } else {
          tip({
            type: 'error',
            presetText: 'ERROR',
            content: result?.data?.error,
          });
        }
        setLoading(false)
        return
      } else {
        if (currentPlan === 'Unlimited' && result.data.url === 'QUOTA_EXCEEDED') {
          setLoading(false)
          tip({
            type: 'error',
            content: t('TIP_PRIMARY_SUBSCRIBE_UNLIMIT_QUOTA'),
          });
          setSubscriptionsUnlimitInfo(pre => {
            return ({
              quota: 0,
              reset_remain: pre.reset_remain,
            })
          }
          )
          return;
        }
        setPlanChange(false)
        setLoading(false)
        tip({
          type: 'success',
          content: t('TIP_SUCCESS_SUB_PLAN_CHANGED'),
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (e) {
      if (e.message === 'OPERATION_NOT_SUPPORTED') {
        tip({
          type: 'error',
          content: t('TIP_ERR_NOT_SUPPORTED_SUB'),
        });
        setShowSubscribe(false)
        setIsFeedbackModalOpen(true)
      }
      console.log('changeplan error', e)
    }
  }

  const handlerCheckType = (type) => {
    trackEvent('Subscribe - IsYearly: Switch', { isYearly:type })
    setYearChecked(type)
  }

  if (!showSubscribe) {
    return null
  }

  const startAnimate = () => {
    CustomEase.create("default", ".25,.1,.25,1")
    CustomEase.create("defaulto", ".58,0,1,.99")
    CustomEase.create("easeinout", ".42,0,.58,1")
    const tl = gsap.timeline({ repeat: -1 });
    // var tl = gsap.timeline();
    tl.fromTo(".subAnimateinit1", { opacity: 1 }, { opacity: 1, duration: 1 })
    tl.fromTo(".subAnimateinit1", { opacity: 1 }, { opacity: 0, duration: 0.5 })
    tl.fromTo(".subAnimate1", { y: 70 }, { y: 0, duration: 0.5, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, ">0.1")
    tl.fromTo(".subAnimate1", { opacity: 0 }, { opacity: 1, duration: 0.4, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.1")
    tl.fromTo(".subAnimate1_1", { y: 70 }, { y: 0, duration: 0.42, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.01")
    tl.fromTo(".subAnimate1_1", { opacity: 0 }, { opacity: 1, duration: 0.4, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.03")
    tl.fromTo(".subAnimate2", { y: 70 }, { y: 0, duration: 0.56, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, ">0")
    tl.fromTo(".subAnimate2", { opacity: 0 }, { opacity: 1, duration: 0.4, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.19")
    tl.fromTo(".subAnimate3", { y: 70 }, { y: 0, duration: 0.58, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<-=0.1")
    tl.fromTo(".subAnimate4", { y: 70 }, { y: 0, duration: 0.58, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0")
    tl.fromTo(".subAnimate3", { opacity: 0 }, { opacity: 1, duration: 0.4, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.18")
    tl.fromTo(".subAnimate4", { opacity: 0 }, { opacity: 1, duration: 0.4, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0")
    tl.fromTo(".subAnimate2_1", { y: 0, opacity: 1 }, { y: -23, opacity: 1, duration: 0.55, ease: CustomEase.create("custom", "M0,0 C0.495,0 0.492,1 1,1 ") }, "<0.4")
    tl.fromTo(".subAnimate2_2", { y: 0 }, { y: -23, duration: 0.55, ease: CustomEase.create("custom", "M0,0 C0.495,0 0.492,1 1,1 ") }, "<0")
    tl.fromTo(".subAnimate2_2", { opacity: 0 }, { opacity: 1, duration: 0.45, ease: CustomEase.create("custom", "M0,0 C0.495,0 0.492,1 1,1 ") }, "<0.1")
    tl.fromTo(".subAnimate5", { x: 80 }, { x: 0, duration: 0.66, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, ">0")
    tl.fromTo(".subAnimate7", { x: 80 }, { x: 0, duration: 0.70, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0")
    tl.fromTo(".subAnimate5", { opacity: 0 }, { opacity: 1, duration: 0.31, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.15")
    tl.fromTo(".subAnimate7", { opacity: 0 }, { opacity: 1, duration: 0.29, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.08")
    tl.fromTo(".subAnimate4_1", { x: -40 }, { x: 120, duration: 0.5, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, ">0.3")
    tl.fromTo(".subAnimate4_2", { opacity: 0 }, { opacity: 1, duration: 0.5, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.01")
    tl.fromTo(".subAnimate4_3", { opacity: 0 }, { opacity: 1, duration: 0.5, ease: CustomEase.create("custom", "M0,0 C0.292,0.095 0.299,1 1,1 ") }, "<0.1")
    tl.fromTo(".subAnimateinit2", { opacity: 1 }, { opacity: 1, duration: 1 })
    tl.fromTo(".subAnimateinit2", { opacity: 1 }, { opacity: 0, duration: 0.5 })
    tl.fromTo(".subAnimateinit1", { opacity: 0 }, { opacity: 1, duration: 0.5 })
    animationRef.current = tl
  }

  return (
    <div className='w-[100vw] h-[100vh] fixed top-0 left-0 bg-[rgba(0,0,0,0.3)] flex-center z-[2000] select-none' onClick={handlerClose}>
      <div
        className={`relative overflow-hidden min-w-[768px] min-h-[385px] w-[768px] h-[385px] xs:w-[1004px] xs:h-[503px] sm:w-[1099px] sm:h-[550px]  md:w-[1256px] md:h-[628px] lg:w-[1508px] lg:h-[755px] xl:w-[1508px] xl:h-[755px] p-[20px] sm:p-[30px] lg:p-[40px] bg-[rgba(35,35,35,0.8)] rounded-2xl flex flex-col items-start
        after:absolute after:w-full after:h-full after:left-0 after:top-0 after:bg-[rgba(35,35,35,0.8)] after:rounded-2xl after:-1`}
        ref={stripeBoxRef}>
        {openEduHover && <EducationPage setFetchver={setFetchver} setOpenEduHover={setOpenEduHover} />}
        <Restricted to={"subscription.header.view"}>
          <SubscriptionManagement />
        </Restricted>
        <div className='w-full flex flex-col items-start relative z-[2]'>
          <div className='flex flex-col items-start justify-center'>
            <div className="subAnimateinit1 opacity-100 text-primary text-[28px] sm:text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px] font-bold leading-[normal] tracking-normal uppercase text-[rgba(255,_255,_255,_1)] relative">{t('SUBSCRIPTION_HEADER_TITLE_1')}</div>
            <div className='subAnimateinit1 opacity-100 text-primary text-[14px] sm:text-[16px] md:text-[18px] font-normal leading-[normal] tracking-normal text-[rgba(184,_184,_184,_1)]'>{t('SUBSCRIPTION_HEADER_TITLE_2')}</div>
            <div className='subAnimateinit2 absolute flex flex-row items-center h-full w-auto gap-[14px] mt-[12px] sm:mt-0'>
              <div className="subAnimate1 text-primary opacity-0 text-[20px] xs:text-[28px] sm:text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px] font-bold leading-[normal] tracking-normal text-[rgba(255,_255,_255,_1)]">Pay by Result</div>
              <div className='subAnimate1_1 opacity-0 h-[35%] w-auto'><img className='h-full w-auto' src={heartIcon} /></div>
              <div className='subAnimate2 h-[78%] xs:h-[96%] opacity-0 aspect-square w-auto flex flex-col items-center px-[2%] relative'>
                <div className='subAnimate2_1 absolute w-full h-[36px] xs:h-[45px] [border:1px_solid_#FFFFFF5E] rounded-[26px] top-[50%] -translate-y-[50%]'>
                  <div className='absolute flex items-center justify-center w-full h-full bg-[#D8D8D827] rounded-[26px] font-bold text-[6px] xs:text-[10px] sm:text-[12px] md:text-[14px] text-[#fff] overflow-hidden
                  after:absolute after:left-[50%] after:top-[50%] after:w-[82%] after:h-[32%] after:-translate-x-[50%] after:-translate-y-[50%] after:content-[""] after:bg-[linear-gradient(180deg,#28E4F0_6%,#28B4F0_100%)] after:rounded-[26px] after:blur-[10px] after:z-[-1]'>
                    GENERATE
                  </div>
                </div>
                <div className='subAnimate2_2 absolute top-[82%] opacity-1 bottom-0 flex items-center justify-center w-full h-[34px] xs:h-[43px] [border:1px_solid_transparent] text-[#4308D7] font-bold text-[6px] xs:text-[10px] sm:text-[12px] md:text-[14px] rounded-[26px] bg-[#EFECF6]
                after:absolute after:w-[100%] after:h-[100%] after:rounded-[26px] after:[border:2px_solid_#4308D7]'>
                  Redo
                </div>
              </div>
              <div className="subAnimate3 text-primary opacity-0  text-[20px] xs:text-[28px] sm:text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px] font-bold leading-[normal] tracking-normal text-[rgba(255,_255,_255,_1)]">for</div>
              <div className={`subAnimate4 relative opacity-1`}>
                <span className={`${style.freeicon} block`}>
                  <div className='subAnimate4_1 flex items-center justify-center z-[999] absolute h-full w-[30%] bg-[rgba(255,255,255,0.4)] [clip-path:polygon(50%_0,100%_0,50%_100%,0_100%)] left-0 top-0 -translate-x-[110%]'>
                    <div className='absolute h-full w-full bg-[rgba(255,255,255,0.3)] [clip-path:polygon(60%_0,90%_0,40%_100%,10%_100%)]' ></div>
                  </div>
                </span>
                <div className='subAnimate4_2 absolute opacity-0 w-[20%] aspect-square h-auto -bottom-[15%] left-0'><img className='w-full [filter:drop-shadow(0px_0px_20px_rgba(255,255,255,1))]' src={starIcon} /></div>
                <div className='subAnimate4_3 absolute opacity-0 w-[10%] aspect-square h-auto -top-[15%] right-[5%]'><img className='w-full [filter:drop-shadow(0px_0px_20px_rgba(255,255,255,1))]' src={star2Icon} /></div>
              </div>
              <div className="subAnimate5 relative flex items-center justify-center text-primary opacity-0 ">
                <span className='text-[20px] xs:text-[28px] sm:text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px] leading-[20px] xs:leading-[28px] sm:leading-[32px] md:leading-[36px] lg:leading-[40px] xl:leading-[44px] font-bold text-[rgba(255,_255,_255,_1)]'>before</span>
              </div>
              <div className='subAnimate7 relative opacity-0 text-[10px] xs:text-[14px] sm:text-[16px] md:text-[18x] leading-[14px] sm:leading-[16px] md:leading-[18x] px-[16px] py-[10px] xs:px-[23px] xs:py-[12px] bg-[#4206D7] rounded-[26px] [border:2px_solid_#FFFFFF] text-[rgba(255,_255,_255,_1)] font-bold'>Confirm</div>
            </div>
          </div>
          <div className={`w-[178px] h-[42px] p-[8px] top-[-20px] sm:top-[-30px] flex items-center text-sm text-[rgba(202,202,202,1)] rounded-[84px] bg-[rgba(0,0,0,0.3)] self-end relative after:content-["-20%"] after:absolute after:m-0 after:right-[0] after:rounded-[2em] after:[box-shadow:2px_2px_6px_0px_rgba(0,_0,_0,_0.29)] after:bg-[rgba(234,154,81,1)] after:text-[#fff] after:px-[0.5em] after:py-[0.2em] after:text-[0.8em] after:[border:2px_solid_rgba(230,224,249,1)]  after:not-italic after:[font-variant:small-caps] after:font-bold after:transition-300-ease ${yearinfo === 'yearly' ? "after:translate-y-[0%] after:translate-x-[30%] after:top-[0]" : "after:translate-y-[0%] after:translate-x-[30%] after:top-[0]"}`}>
            {['monthly', 'yearly'].map((item) => {
              return (
                <span
                  className={`cursor-pointer relative h-full flex-center font-bold flex-1 rounded-full transition-300-ease border ${yearinfo === item ? "bg-[rgb(230,224,249)] text-[rgba(74,0,224,1)] border-[rgba(175,149,237,1)]" : yearinfo === 'yearly' ? "[background:transparent] text-[rgba(202,202,202,1)] border-transparent" : "[background:rgba(0,0,0,0.3)] text-[rgba(202,202,202,1)] border-transparent"}`}
                  key={item}
                  onClick={() => { handlerCheckType(item) }}>
                  {item === 'yearly' ? t('SUBSCRIPTION_YEARLY') : t('SUBSCRIPTION_MONTHLY')}
                </span>
              )
            })}
          </div>
        </div>
        <div className='flex w-full h-full justify-between relative z-[2]'>
          <div className='flex flex-col justify-between h-[275px] xs:h-[360px] sm:h-[395px] md:h-[451px] lg:h-[542px] xl:h-[541px]'>
            <MyPlanTier myPlanHover={myPlanHover} setMyPlanHover={setMyPlanHover} />
            <EducationTier loading={loading} myPlanHover={myPlanHover} setLoading={setLoading} fetchver={fetchver} setFetchver={setFetchver} yearChecked={yearChecked} setOpenEduHover={setOpenEduHover} />
          </div>
          <CreatorTier
            yearChecked={yearChecked}
            creatorPriceIndex={creatorPriceIndex}
            handlerChoosePlan={handlerChoosePlan}
            setCreatorPriceIndex={setCreatorPriceIndex}
            loading={loading} />
          <BussinessTier
            yearChecked={yearChecked}
            businessPriceIndex={businessPriceIndex}
            handlerChoosePlan={handlerChoosePlan}
            setBusinessPriceIndex={setBusinessPriceIndex}
            loading={loading} />
          <div className='flex flex-col justify-between h-[275px] xs:h-[360px] sm:h-[395px] md:h-[451px] lg:h-[542px] xl:h-[541px]'>
            {/* {!yearChecked && <Unlimited
              handlerChoosePlan={handlerChoosePlan}
              loading={loading}
              yearChecked={yearChecked}
              renewalInfo={subscriptionsUnlimitInfo}
            />} */}
            <EnterpriseTier setShowSubscribe={setShowSubscribe}
              loading={loading}
              yearChecked={yearChecked} />
          </div>
        </div>
        <div className='absolute z-[1] blur-[50px] bg-[rgba(245,157,92,1)] w-[397px] h-[397px] top-[-171px] left-[357px] opacity-[0.15] rounded-full'></div>
        <div className='absolute z-[1] blur-[50px] bg-[rgba(144,109,226,1)] w-[445px] h-[445px] top-[-248px] left-[120px] opacity-[0.3] rounded-full'></div>
        <div className='absolute z-[1] blur-[50px] bg-[rgba(91,42,206,1)] w-[480px] h-[480px] top-[66px] right-[-30px] opacity-[0.3] rounded-full'></div>
      </div>
      {planChange && <div ref={upgradeRef} onClick={handlerCloseUpgrade} className='fixed z-[999] h-[100vh] w-[100vw] bg-[#00000080] inset-0 flex justify-center items-center'>
        <div ref={upPageRef} className='flex flex-col items-center justify-between w-[45vh] max-w-[482px] min-w-[382px] aspect-[1.6/1]  bg-[#d8d8d8] rounded-2xl gap-2 px-6 py-6 text-[#2D2D2D]'>
          <span className=' font-bold text-xl'>{t('SUBSCRIPTION_PLAN_CHANGE_TITLE')}  </span>
          <span className='text-sm text-left text-[#666666]'>{t('SUBSCRIPTION_PLAN_CHANGE_DESC')}
            <span className='text-[#2D2D2D] font-bold'>{t('SUBSCRIPTION_PLAN_CHANGE_TIP')}</span>
          </span>
          <div className='flex flex-row w-full justify-between text-sm mt-2'>
            <button onClick={() => { setPlanChange(false) }} className='w-[48%] py-2 rounded-3xl bg-[#B0B0B080]'>{t('SUBSCRIPTION_PLAN_CHANGE_BTN_CANCEL')}</button>
            <button onClick={loading ? () => { } : ConfirmPlan} className={`w-[48%] py-3 rounded-3xl text-white [background:linear-gradient(180deg,#6D49FF_0%,#A347FF_100%)] ${loading ? ' cursor-not-allowed' : ' cursor-pointer'}`}>{t('SUBSCRIPTION_PLAN_CHANGE_BTN_PAY')}</button>
          </div>
        </div>
      </div>}
    </div>
  )
}

const SubscribeButton = () => {
  const { t } = useTranslation();
  const apiRef = useRef(null)
  const BusRef = useRef(null)
  const [, setYearChecked] = useRecoilState(showSubscribeTimesAtom)
  const setShowApiDashboard = useSetRecoilState(showApiDashboardAtom)
  const setShowSubscribe = useSetRecoilState(showSubscribeAtom)
  const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  const subscriptionsPreInfo = useRecoilValue(subscriptionsPreInfoAtom)
  const currentNav = useRecoilValue(currentNavAtom);
  const [dashboardHover, setDashboardHover] = useState(false)
  const logInfo = useRecoilValue(logInfoAtom)
  const { isCreatorOrAbove } = useContext(PermissionContext);
  const promotions = useRecoilValue(promotionsAtom)

  const handlerToSubscribe = (e) => {
    if (apiRef.current && apiRef.current.contains(e.target)) {
      return
    } else {
      if ((!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 && BusRef.current && BusRef.current.contains(e.target)) {
        setYearChecked('monthly')
      }
      ReactGA.event(
        {
          category: 'ui_click',
          action: 'open_subscribe',
          label: 'header'
        }
      )
      trackEvent('Subscribe - Page: Open')
      setShowSubscribe(true)
    }
  }

  const handlerToApiDashboard = () => {
    // This will force user navi back to rodin if they are in other module
    try {
      const url = new URL(window.location.href)
      url.pathname = "/api-dashboard"
      // window.history.pushState(
      //   { page: "api-dashboard" },
      //   "ApiDashboard Page",
      //   url
      // );
    } catch (e) {
      Sentry.captureException(e)
      console.error(e)
    }
    setShowApiDashboard(true)
  }

  const subTitle = [{
    planlevel: 'Education',
    name: t('SUBSCRIPTION_PLAN_EDUCATION')
  }, {
    planlevel: 'Creator',
    name: t('SUBSCRIPTION_PLAN_CREATOR')
  }, {
    planlevel: 'Business',
    name: t('SUBSCRIPTION_PLAN_BUSINESS')
  }, {
    planlevel: 'Enterprise',
    name: t('SUBSCRIPTION_PLAN_ENTERPRISE')
  }, {
    planlevel: 'Unlimited',
    name: t('SUBSCRIPTION_PLAN_UNLIMITED')
  }]

  return (
    <>
      <div
        onClick={handlerToSubscribe}
        id='subCheck'
        className={`${promotions.newUser.active ? 'mr-2 sm:mr-4' : 'mr-auto'}  ${style.Membership} ${!isCreatorOrAbove() ? style.noSub : ""}`}>
        <Restricted to="subscription.header.view">
          <div className={`${style.content} ${localStorage.getItem('defaultI18n') && localStorage.getItem('defaultI18n') === 'zh' ? '[font-style:normal]' : '[font-style:italic]'}`} >
            {subTitle.filter(item => item.planlevel === subscriptionsInfo.plan_level)[0]?.name || t('WALLET_POPUP_HEADER_2')}
          </div>
        </Restricted>

        <div className={style.subSelectorWrapper}>
          <div className='relative shrink-0 w-[253px] sm:w-[283px] border border-transparent hover:border-white transition-300-ease flex flex-col items-start py-[10px] px-[20px] rounded-2xl bg-[linear-gradient(116.99deg,#875DE7_17.95%,#A08BD5_78.53%)]'>
            {subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && <div className="absolute gap-1 right-[10px] top-[10px] flex items-center px-[10px] py-[3px] bg-[linear-gradient(96.13deg,#FB5F1F_-4.12%,#F7AF31_102.42%)] [border-radius:3.51px_10.54px_3.51px_14px] lg:[border-radius:3.51px_10.54px_3.51px_15px] text-primary text-[#fff] font-bold ">
              <span className='text-[20px] md:text-[31px]'>7</span>
              <span className='flex flex-col'>
                <span className='text-[10px] leading-3'>FREE</span>
                <span className='text-[12px] md:text-[14px] leading-3 '>-DAY</span>
              </span>
            </div>}
            <span className='text-[24px] font-bold text-white'>{t('SUBSCRIPTION_PLAN_CREATOR')}</span>
            <div className='text-[16px] leading-[16px] pt-[10px] pb-[22px] text-white'>
              <span className='relative pr-3 h-fit inline-block'>
                <span className='text-[28px] sm:text-[32px] font-bold'>{24}</span>
                <img className='absolute right-0 top-0 -translate-y-[50%] w-[6px] h-auto' src={subPrice} alt="$" />
              </span>
              <span className='text-subscription-price-sm'>/ {t('SUBSCRIPTION_MONTH')}</span>
            </div>
            <span className='text-subscription-price-sm text-[#F3F3F3]'>
              <span>{30}</span>
              <span>&nbsp;{t('SUBSCRIPTION_CREDIT_MONTHLY')}</span>
            </span>
          </div>
          <div ref={BusRef} className={`relative shrink-0 w-[253px] sm:w-[283px] border border-transparent ${dashboardHover ? '' : 'hover:border-white'} transition-300-ease  flex flex-col items-start py-[10px] px-[20px] rounded-2xl bg-[linear-gradient(128.84deg,rgba(250,191,101,0.8)_-6.41%,rgba(202,153,158,0.8)_33.22%,rgba(149,117,227,0.8)_97.1%)]`}>
            <div className='w-full flex flex-row justify-between items-center'>
              {(!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 && <div className="absolute gap-1 right-[10px] top-[10px] flex items-center px-[10px] py-[3px] bg-[linear-gradient(97.95deg,#45E1FF_-22.77%,#FF8235_115.3%)] [border-radius:3.51px_10.54px_3.51px_14px] lg:[border-radius:3.51px_10.54px_3.51px_15px] text-primary text-[#fff] font-bold ">
                <div className='flex flex-row items-start'>
                  <span className='text-[20px] md:text-[28px] lg:text-[31px]'>50</span>
                  <span className='text-[10px]'>%</span>
                </div>
                <span className='flex flex-col w-[22px]  h-[25px] xs:w-[22px] md:w-[26px] md:h-[28px] xs:h-[25px] lg:w-[30px]  lg:h-[30px] relative items-center'>
                  <span className='text-[9px] md:text-[12px] lg:text-[12px] absolute top-0 right-0'>OFF</span>
                  <span className='text-[8px] md:text-[9px] lg:text-[10px] absolute whitespace-nowrap bottom-0 right-0'>First Mo</span>
                </span>
              </div>}
              <span className='text-[24px] font-bold text-white'>{t('SUBSCRIPTION_PLAN_BUSINESS')}</span>
              {logInfo && <Restricted to="api.view">
                <div onMouseEnter={setDashboardHover.bind(null, true)} onMouseLeave={setDashboardHover.bind(null, false)} className='transition-300-ease bg-[rgba(255,255,255,0.2)] hover:bg-[rgba(255,255,255,0.4)] cursor-pointer text-[rgba(255,255,255,1)] absolute flex justify-center items-center bottom-[10px] right-[10px] text-[12px] px-[12px] py-[4px] rounded-3xl'>
                  <div ref={apiRef} onClick={handlerToApiDashboard} className='whitespace-nowrap'>{t('WALLET_POPUP_DASHBOARD')}</div>
                </div>
              </Restricted>}
            </div>
            {/* <span className='text-[24px] font-bold text-white'>Business</span> */}
            <div className='text-[16px] leading-[16px] pt-[10px] pb-[22px] text-white'>
              {(!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 && <span className='absolute text-[rgba(255,255,255,0.6)] text-[9px] sm:text-[11px] translate-y-[22px] '>$120 / month thereafter</span>}
              <span className='relative pr-3 h-fit inline-block'>
                <span className='text-[28px] sm:text-[32px] font-bold'>{(!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 60 : 96}</span>
                <img className='absolute right-0 top-0 -translate-y-[50%] w-[6px] h-auto' src={subPrice} alt="$" />
              </span>
              <span className={`text-subscription-price-sm`}>/ {(!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 'first mo.' : t('SUBSCRIPTION_MONTH')}</span>
              {/* {subscriptionsInfo.plan_level!=='Business'  && <span className='absolute bg-[linear-gradient(96.13deg,#FB5F1F_-4.12%,#F7AF31_102.42%)] text-[7px] md:text-[8px] px-[2px] md:px-[6px] rounded-md -translate-x-8 md:-translate-x-12 -translate-y-2'>70% OFF</span>} */}
            </div>
            <span className='text-subscription-price-sm text-[rgba(243,243,243,1)]'>
              <span>{208}</span>
              <span>&nbsp;{t('SUBSCRIPTION_CREDIT_MONTHLY')}</span>
            </span>
          </div>
          <div className='relative shrink-0 w-[253px] sm:w-[283px] border border-transparent hover:border-white transition-300-ease  flex flex-col items-start py-[10px] px-[20px] rounded-2xl bg-[linear-gradient(128.84deg,rgba(135,113,255,1)_33.22%,rgba(124,181,223,1)_97.1%)]'>
            <span className='text-[24px] font-bold text-white'>{t('SUBSCRIPTION_PLAN_EDUCATION')}</span>
            <div className='text-[16px] leading-[16px] pt-[10px] pb-[22px] text-white'>
              <span className='relative pr-3 h-fit inline-block'>
                <span className='text-[28px] sm:text-[32px] font-bold'>12</span>
                <img className='absolute right-0 top-0 -translate-y-[50%] w-[6px] h-auto' src={subPrice} alt="$" />
                <span className='absolute translate-y-[40%] -right-4 text-[14px] sm:text-[18px] font-bold line-through text-[rgba(214,214,214,0.7)] decoration-white'>24</span>
              </span>
              <span className='text-subscription-price-sm ml-5'>/ {t('SUBSCRIPTION_MONTH')}</span>
            </div>
            <span className='text-subscription-price-sm text-[rgba(243,243,243,1)]'>
              <span>{30}</span>
              <span>&nbsp;{t('SUBSCRIPTION_CREDIT_MONTHLY')}</span>
            </span>
          </div>
          <div className='relative shrink-0 w-[253px] sm:w-[283px] border border-transparent hover:border-white transition-300-ease  flex flex-col items-start py-[10px] px-[20px] rounded-2xl bg-[linear-gradient(116.99deg,#7D5EC2_15.27%,#5A86DC_100%)]'>
            <span className='text-[24px] font-bold text-white'>{t('SUBSCRIPTION_PLAN_ENTERPRISE')}</span>
            <div className='text-[18px] font-bold w-full text-right text-white'>
              <span className='text-right [border-bottom:1px_solid_#fff]'>{t('SUBSCRIPTION_LET_TALK')}</span>
            </div>
          </div>
        </div>

      </div>
      {/* <Subscribe /> */}
    </>
  )
}

export { Subscribe, SubscribeButton }